module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p11.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "pagebreak1"
  }, [_c('br')])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "start1"
  })]), _c('p', {
    staticClass: "bhead"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('i', [_vm._v("Appetizers")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page_15"
    }
  }, [_c('b', [_vm._v("HORS D’OEUVRES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_25"
    }
  }, [_c('b', [_vm._v("DIPS & SPREADS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_30"
    }
  }, [_c('b', [_vm._v("SNACKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_35"
    }
  }, [_c('b', [_vm._v("SMALL DISHES")])])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak1"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('h1', [_vm._v("APPETIZERS"), _c('br'), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "abst"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("F ALL THE PLEASURES")]), _vm._v(" associated with eating, anticipation is one of the best. The moment when a heavenly aroma sneaks around the kitchen door, heralding the repast to come, is wonderful. But it can also be tough: Our stomachs grumble; our mouths water. How can we bear the wait until dinner is served? Enter appetizers, those much-loved nibbles that precede the meal, calming the appetite in advance of the dishes to come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For cooks the world over, these savory tidbits buy time and set the mood, curbing hunger and putting an edible welcome on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first known use of the English word "), _c('i', [_vm._v("appetizer")]), _vm._v(" was in 1820, but, of course, preprandial treats have been around a lot longer. Ancient Greeks snacked on raw and cured olives, bits of fish and nuts. According to Apicius, early Romans were likely to start with what may be one of the original versions of deviled eggs. French aristocrats of the 17th century sated themselves with small plates of oysters, pâtés, and, yes, stuffed eggs. They called these bites "), _c('i', [_vm._v("hors d’oeuvres,")]), _vm._v(" meaning “out of the ordinary course of things.” In other words, such foods were not the meal, but rather the meal’s extraordinary accompaniments. It’s a definition we heartily endorse: Spanish-style "), _c('i', [_vm._v("pan con tomate")]), _vm._v(", the juice of the ripe tomato soaking into the garlicky bread; "), _c('i', [_vm._v("pissaladière")]), _vm._v(", a French tart pungent with onion and anchovy; Malaysian chicken satay fragrant with ginger and lemongrass—all are indeed extraordinary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Modest in size and extravagant in flavor, appetizers like these prime everyone at the table for enjoyment. We can think of nothing better to offer the people with whom we choose to dine than a delectable morsel made with care. Whether oysters Rockefeller from the broiler, topped with bread crumbs laced with butter and tarragon, pita slathered with baba ghannouj, a smoky mashed eggplant spread, or a quickly made batch of Mexican spiced nuts, an appetizer gives our dining companions the license to dig in with gusto. By any name—antipasto, tapa, mezze, "), _c('i', [_vm._v("entrada")]), _vm._v("—it’s an edible greeting of immediate impact delivering the simple message, “We’re glad you’re here.”")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak1"
  }, [_c('br')])]), _c('h2', [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('i', [_vm._v("Hors d’Oeuvres")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("BAKED FETA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Crumbly, salty feta takes on a whole new dimension when it’s baked in the oven.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. firm feta")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tsp. extra-virgin olive oil"), _c('br'), _vm._v("Crushed red chile flakes"), _c('br'), _vm._v("Crusty bread, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 400°. Cut feta into 4 slices about 3″×4″ and "), _c('b', [_vm._v("½")]), _vm._v("″ thick. Place each slice on a large piece of aluminum foil, drizzle with 1 tsp. oil, and sprinkle with chile flakes. Wrap foil around cheese, closing it and folding it over to seal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Place foil packets on a baking sheet and bake until cheese is slightly soft, about 10 minutes. Transfer to 4 plates, remove foil, and drizzle with remaining 2 tsp. oil. Serve with bread.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" Use tinned feta rather than the barrel-aged variety, which can be too soft and creamy for this dish.")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("THE FACTS")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("ON FETA")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_vm._v("Feta, the definitive Greek cheese, salty and sourish and earthy, is descended from the soft, tart goat’s-milk cheeses that have been made in the Balkans, and especially in Greece and Bulgaria, for centuries. The Greek word "), _c('i', [_vm._v("feta")]), _vm._v(" means “slice”–the form in which the cheese is customarily served. (It is not an old name; it was probably coined by a market-savvy cheese-monger or producer around the turn of the 20th century.) Greek law decrees that feta must be made from at least 70 percent ewe’s milk and up to 30 percent goat’s milk. Each animal produces one to three kilos of milk per day; it takes at least four kilos to make a kilo of cheese. The more goat’s milk in the mix, the firmer the cheese will be.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("ELLA FITZGERALD’S FAVORITE CHEDDAR CHEESE LOG")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ONE 8″ LOG")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("No less than jazz legend Ella Fitzgerald flagged this recipe in her copy of "), _c('i', [_vm._v("James Beard’s American Cookery")]), _vm._v(". This vintage hors d’oeuvre has won over cocktail partygoers for decades with its smooth cheddar cheese texture sharpened with the heat of Tabasco and Dijon mustard.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("lb. cheddar cheese (mild, medium or sharp), grated")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. Dijon mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. Tabasco sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped pimiento")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup coarsely chopped pecans")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put room-temperature cheddar cheese in a large bowl. Add mustard, Tabasco, parsley, and pimientos. Mix until ingredients are evenly distributed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Place a piece of plastic wrap about 9″ long on a clean surface. Mound cheese mixture along edge nearest you, then roll in plastic, pressing and molding to form a log about 1"), _c('b', [_vm._v("½")]), _vm._v("″ wide and 8″ long.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Carefully remove plastic wrap and roll log in chopped pecans, pressing nuts into log as you roll. Rewrap log with fresh plastic wrap and chill for at least 1 hour. Serve with crackers.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CHICKEN LIVER PÂTÉ")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 1"), _c('b', [_vm._v("⅓")]), _vm._v(" CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("A smart cook never tosses the jewels found inside a whole chicken, especially the liver. Sautéed and blended, liver transforms into a velvety pâté, spiked with cognac and mellowed with sweet sautéed onions.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. chicken livers, cleaned")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cups chicken stock")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. rendered chicken fat or unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("medium yellow onion, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. cognac or brandy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("2")])]), _c('td', [_vm._v("hard-cooked eggs"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste"), _c('br'), _vm._v("Toast points, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Bring livers and stock to a boil in a 4-qt. saucepan over medium-high heat. Reduce heat to medium-low and cook until just cooked through, about 8 minutes. Drain, reserving "), _c('b', [_vm._v("¼")]), _vm._v(" cup cooking liquid, then transfer to a food processor. Heat fat in a 10″ skillet over high heat, add onion, and cook until browned, about 4 minutes. Transfer to food processor. Add reserved cooking liquid, cognac, egg, salt, and pepper and purée. Serve with toast points.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("GOUGÈRES")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 2"), _c('b', [_vm._v("½")]), _vm._v(" DOZEN")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("These feather light, tender pastry puffs are flavored with Gruyère cheese and baked until golden brown. They’re best eaten right out of the oven, when the warm cheese is at its most aromatic.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup milk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("tbsp. unsalted butter, cubed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("eggs, at room temperature")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("oz. Gruyère cheese, grated")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 425°. Bring milk, butter, salt, and "), _c('b', [_vm._v("½")]), _vm._v(" cup water to a boil in a 4-qt. saucepan over high heat. Add flour and stir until dough forms. Reduce heat to medium and cook, stirring dough constantly with a wooden spoon, until slightly dried, about 2 minutes. Transfer to a bowl. Using a hand mixer, beat in one egg until smooth. Repeat with remaining eggs, beating them in one at a time, until dough is smooth. Stir in cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Using a large tablespoon, drop balls of dough onto parchment paper–lined baking sheets. Reduce oven temperature to 375° and bake until golden brown, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("PIMIENTO CHEESE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 4 CUPS; SERVES 16")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("There are as many variations on pimiento cheese—the iconic spread of cheese, mayonnaise, red pepper, and spices—as there are opinionated Southern cooks. This simple, perfect version comes from Doris Kemp, owner of Mammy’s Cupboard in Natchez, Mississippi. She insists on using Duke’s mayonnaise, a tart, tangy, less-sweet-than-Hellman’s spread that’s an essential part of the Southern pantry.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("PUFF")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("PERFECT")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_c('i', [_vm._v("Gougères")]), _vm._v(", the irresistible French cheese puffs traditionally served with apéritifs in Burgundy, might well be the perfect hors d’oeuvre: With their delicate crisp walls and soft, cheese-laced, eggy interior, they are light enough to whet your appetite but rich enough to satisfy premeal cravings. The secret of the puff? According to chef Jean-Pierre Silva of Le Vieux Moulin in Bouilland, it’s all in how you construct the dough: Adding the flour all at once, and the eggs one at a time. This produces a perfectly airy, lofty dough.")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. sharp yellow cheddar cheese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("8-oz. jar diced pimientos, drained")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("8-oz. package cream cheese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup Duke’s mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. garlic salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. cayenne pepper Crackers, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Grate cheddar cheese into the bowl of a stand mixer fitted with a paddle. Add pimientos, cream cheese, mayonnaise, garlic salt, and cayenne (or to taste). Beat on medium speed until smooth, about 1 minute. Serve with crackers.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CHINESE MINCED CHICKEN LETTUCE WRAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("These crisp Cantonese wraps are a lesson in textural contrast—and they’re packed with flavor. The chicken marinates in a powerful combination of soy sauce, oyster sauce, and rice wine.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. ground chicken")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("20")]), _c('td', [_vm._v("cashews, roughly chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("dried shiitake mushrooms, softened in hot water, stemmed, and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("scallions, 2 finely chopped, the green part of 1 julienned")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tsp. soy sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. oyster sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("1")])]), _c('td', [_vm._v("tbsp. rice wine or dry sherry")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. cornstarch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. sugar"), _c('br'), _vm._v("Kosher salt and freshly ground white pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. peanut oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("16")]), _c('td', [_vm._v("leaves iceberg lettuce Sweet Asian chile sauce, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put chicken, cashews, mushrooms, and chopped scallions into a bowl. Mix soy sauce, oyster sauce, wine, cornstarch, sugar, salt, and pepper in a bowl. Pour over chicken and toss well. Let marinate for 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat oil in a 12″ skillet over high heat. Add garlic and cook for 10 seconds. Add chicken mixture and cook, stirring, until browned, about 3 minutes. Transfer chicken to a bowl. To serve, spoon some chicken onto each lettuce leaf. Garnish with julienned scallion and chile sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("NEGIMA YAKITORI")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Chicken & Scallion Skewers with Yakitori Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Japanese chicken skewers are marvels of simplicity. A basting of homemade yakitori sauce, salty and deep thanks to roasted chicken bones, combines with the smoke of the grill and the sweetness of scallions to bring out remarkable flavor in the chicken.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("whole, bone-in chicken legs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups mirin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups soy sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup dry sake")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. packed dark brown sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("16")]), _c('td', [_vm._v("large scallions, cut into 1″ pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("5")]), _c('td', [_vm._v("cloves garlic, crushed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("2″ piece fresh ginger, peeled and thinly sliced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("16")]), _c('td', [_vm._v("bamboo skewers, soaked in water for 30 minutes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the yakitori sauce: Arrange an oven rack 4″ from broiler and heat broiler. Remove bones from chicken legs and cut bones into small pieces. Cut chicken meat into "), _c('b', [_vm._v("¼")]), _vm._v("″-thick slices; refrigerate until ready to use. Transfer bones to a foil-lined baking sheet and broil, turning, until browned all over, about 10 minutes. Transfer bones to a 4-qt. saucepan and add mirin, soy sauce, sake, sugar, pepper, green parts of scallions, garlic, ginger, and 1 cup water. Bring to a boil, reduce heat to medium-low, and cook until liquid is reduced by half, about 1"), _c('b', [_vm._v("½")]), _vm._v(" hours. Pour through a fine-mesh sieve into a bowl and let sauce cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Working with 1 skewer at a time, alternately thread 4 slices chicken with 3 pieces of white parts of scallions, piercing chicken slices through their ends to form folded slices and piercing scallion pieces perpendicular to skewer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Build a medium fire in a charcoal grill or heat a gas grill to medium. (Alternatively, heat a cast-iron grill pan over medium-high heat.) Add skewers and cook, turning, until beginning to brown, about 6 minutes. Brush with yakitori sauce and continue cooking, turning and basting with sauce every 30 seconds, until cooked through and sauce forms a glaze on chicken, about 2 minutes more. Transfer to a serving plate and drizzle with more yakitori sauce; serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("MALAYSIAN CHICKEN SATAY")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Satay Ayam")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 30 SKEWERS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Malaysia’s version of chicken satay, called "), _c('i', [_vm._v("satay ayam")]), _vm._v(", comes from the northeast coast and is marinated in a spice market’s worth of seasonings, from ginger to fennel to coriander. It’s served with a rich, piquant peanut sauce—in Malaysia, the street hawkers who sell satay each have their own variation, some spicier, some sweeter, some more sour.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("tbsp. peanut oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup packed dark brown sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. ground coriander")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground turmeric")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground fennel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("cloves garlic, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("stalks lemongrass, trimmed and chopped, plus 1 stalk, whole")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("large shallots, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("5″ piece fresh ginger, peeled and chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3"), _c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. skinless, boneless chicken thighs, cut into 1″-wide, "), _c('b', [_vm._v("¼")]), _vm._v("″-thick slices")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("30")]), _c('td', [_vm._v("bamboo skewers, soaked in water for 30 minutes"), _c('br'), _c('span', {
    attrs: {
      "href": "#/cap15#page_579",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Sauce")]), _vm._v(", for serving")])])])])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Process 2 tbsp. oil with sugar, coriander, turmeric, fennel, salt, garlic, chopped lemongrass, shallots, and ginger in a food processor until smooth. Mix paste and chicken in a bowl; chill for 4 hours. Using a meat mallet, strike thick end of lemongrass stalk until it splits into threads resembling ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("a brush. Place shattered end in a bowl and pour in remaining 4 tbsp. oil.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Build a hot fire in a charcoal grill or heat a gas grill to high. Thread 2 pieces of chicken on each skewer. Grill, turning once and brushing with oil from lemongrass brush, until charred, 5–6 minutes. Serve at once with peanut sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("THE WORLD")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("OF SATAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_c('b', [_vm._v("“")]), _vm._v("Satay is the quintessence of fast food in Southeast Asia. You’ll find it sizzling over hot coals practically 24 hours a day—at night markets, in busy hawker stalls, or offered by mobile vendors who prepare it to order. These cooks carry bamboo rods across their shoulders, balancing a basketful of the marinated meat and condiments on one side and a small grill filled with hot coals on the other. When a vendor is waved down by a customer, he sets up his mobile kitchen on the ground and starts cooking. Within minutes, the skewers are charred and ready to eat."), _c('b', [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "right11"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JAMES OSELAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("TOFU WANZI")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Fried Tofu & Bacon Fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 3"), _c('b', [_vm._v("½")]), _vm._v(" DOZEN")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("China meets the American South in these exquisite tofu, bacon, and scallion fritters, an invention of writer Mei Chin’s grandmother, who emigrated from China to Richmond, Virginia. They’re a perfect expression of cross-cultural culinary fusion.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("12"), _c('b', [_vm._v("½")]), _vm._v("-oz. boxes soft or silken tofu")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("12"), _c('b', [_vm._v("½")]), _vm._v("-oz. box firm tofu")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅔")])]), _c('td', [_vm._v("cup panko bread crumbs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup Asian sesame oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("5")]), _c('td', [_vm._v("scallions, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("slices bacon, cooked and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("eggs, lightly beaten"), _c('br'), _vm._v("Kosher salt and freshly ground white pepper, to taste Canola oil, for frying")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Place all the tofu on a bed of paper towels on a baking sheet and cover with more paper towels and another baking sheet. Place a cast-iron skillet on sheet to weight it down; refrigerate until tofu is drained of most of its liquid, at least 6 hours or up to overnight. Transfer pressed tofu to a large bowl and mash coarsely with a fork. Stir in panko, flour, sesame oil, scallions, bacon, eggs, and salt and pepper until evenly combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Pour oil to a depth of 2″ into a 6-qt. Dutch oven and heat over medium-high heat until a deep-fry thermometer reads 350°. Portion 2 tbsp. of the tofu mixture and form into a miniature football shape using 2 spoons; repeat with remaining tofu mixture. Fry until golden brown and crisp, about 2 minutes. Season with salt and serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("TUNA MELT CANAPÉS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 2")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This bite-size riff on a tuna melt gets a facelift from curry powder, raisins, and chutney—unexpected partners, but they work together beautifully.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2–3")]), _c('td', [_vm._v("tbsp. mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. raisins")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. mango chutney, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. curry powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("5-oz. can oil- or water-packed tuna, drained"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("slices white bread, crusts removed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("thin, square slices cheddar cheese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("1″ pieces fresh chives, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Arrange an oven rack 10″ from broiler and heat broiler. Combine mayonnaise, raisins, chutney, curry, and tuna in a bowl and season with salt and pepper; set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Cut each slice of bread and cheese into 4 triangles. Spoon tuna salad on top of bread pieces and top with cheese. Broil triangles until cheese is melted, 3–4 minutes. Serve garnished with chives.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  })]), _c('p', {
    staticClass: "center_s"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("BETTER")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("WITH BACON")])])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("From artichokes to zucchini, almost everything is improved when it’s wrapped in smoky, salty bacon.")])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("JALAPEÑOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_vm._v("You don’t need breading to make perfect poppers. Grill seeded jalapeños and stuff them with cream cheese; wrap the peppers in bacon and grill until golden and crispy, about 10 minutes. Serve them with fresh tomato salsa to tame the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("ARTICHOKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_vm._v("Place a drained, jarred artichoke heart on the end of a piece of raw bacon, sprinkle it with Parmigiano and black pepper, roll it up, and secure with a toothpick. Heat canola oil poured to a depth of 2″ into a Dutch oven to 350° and fry the artichokes until golden brown, about 3 minutes. Sprinkle with more cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("SCALLIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_vm._v("Butcher shops all across Sicily sell bacon-wrapped scallions called "), _c('i', [_vm._v("cipollate con pancetta")]), _vm._v(". Bunch 3 scallions together and tie with bacon. Sauté in a skillet until bacon is browned and crispy on all sides, 6–8 minutes. Serve immediately, or snack on them at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("DATES")])])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_vm._v("At The Red Cat, a New York City restaurant, almost every table orders these dates. Insert an almond into the cavity of a pitted Medjool date, and pipe in soft goat cheese to fill any empty space. Wrap each date in a "), _c('b', [_vm._v("½")]), _vm._v(" slice bacon and place seam side down on a baking sheet. Cook at 500° until bacon is crisp, 6–8 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("CHICKEN LIVERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_vm._v("To make "), _c('i', [_vm._v("rumaki,")]), _vm._v(" the tiki bar appetizer that took the 1960s by storm, place a water chestnut in the middle of a raw slice of bacon, then top with "), _c('b', [_vm._v("½")]), _vm._v(" a chicken liver. Place a drop of soy sauce, a pinch of minced fresh ginger, and a sprinkle of brown sugar on top, then wrap in bacon and secure with a skewer. Bake, turning once, in a 400° oven until crisp and golden all over.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18e.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("SARDINES")])])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_vm._v("Wrap oil-packed sardines from a tin in 1 slice of bacon per sardine and secure with a toothpick. Heat canola oil poured to a depth of 2″ into a Dutch oven to 350° and fry until bacon is crisp, about 2 minutes. Serve over toasted white bread, sprinkled with chopped fresh herbs like parsley or chervil.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("FRIED WHITEBAIT")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("A standard menu item in the ouzo bars of Athens, these tiny, deep-fried fish—about 3″ long and eaten whole, heads and all—are as addictive as French fries.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("1")])]), _c('td', [_vm._v("lb. whitebait or smelts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. kosher salt"), _c('br'), _vm._v("Freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cups vegetable oil, for frying"), _c('br'), _vm._v("Coarse salt (optional) and lemon wedges, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Wash and drain fish (since they’re so small, it is not necessary to clean or bone them). On a large plate, combine flour with salt and several grinds of pepper. Dredge fish in flour, shaking off any excess.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Pour oil to a depth of 2″ into a 6-qt. Dutch oven and heat over medium-high until a deep-fry thermometer reads 350°. (Test the oil by dropping in a fish; it should sizzle vigorously and, after sinking to the bottom, quickly rise to the top.) Gently place half the fish in the oil and fry until crisp and golden, about 3 minutes. Remove with a slotted spoon and drain on paper towels. Repeat with remaining fish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Mound hot fried fish on a plate and sprinkle with coarse salt, if desired. Serve immediately with lemon wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" Don’t crowd the fry pot with too many fish. The temperature will drop and the fish won’t be crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SHRIMP & HERB CANAPÉS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 14–16")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Time-Life’s "), _c('i', [_vm._v("Good Cook")]), _vm._v(" series of cookbooks from the 1970s and 1980s is filled with timeless classics. Among our favorite recipes is this one for a duo of canapés made with herb and shrimp butters, which we’ve adapted.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups packed watercress leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup packed fresh flat-leaf parsley leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup packed fresh tarragon leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. (4 sticks) unsalted butter, softened")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tbsp. fresh lemon juice"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. medium shrimp, unpeeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("loaf Pullman bread, cut lengthwise into six "), _c('b', [_vm._v("¼")]), _vm._v("″-thick slices, crusts removed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. capers, rinsed, for garnish")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("radishes, thinly sliced, for garnish")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("fresh chives, cut into 2″ lengths, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" To make the herb butter: Combine watercress, parsley, tarragon, and "), _c('b', [_vm._v("½")]), _vm._v(" cup water in a food processor and purée into a smooth paste. Transfer to a 2-qt. saucepan, place over medium heat, and cook, without stirring, until mixture barely begins to simmer. Remove from heat and let sit for 10 minutes. Using a slotted spoon, scoop the herb solids from the liquid and transfer to paper towels to drain. Squeeze paper towels around herbs to remove any excess liquid, and then transfer herb solids to a food processor along with 2 sticks butter and 2 tbsp. lemon juice; process until smooth. Transfer to a bowl, season with salt and pepper, and set herb butter aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" To make the shrimp butter: Bring a 2-qt. saucepan of water to a boil. Add shrimp and cook until just cooked through, about 4 minutes. Drain, peel, and devein. Set aside 4 shrimp to slice thinly lengthwise for garnish. Finely chop remaining shrimp; transfer to a food processor along with remaining butter and lemon juice and process until smooth. Transfer to a bowl, season with salt and pepper, and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Thinly spread some of the herb butter over half the bread slices; thinly spread some of the shrimp butter over the remaining bread slices. Transfer each butter to a separate piping bag fitted with a "), _c('b', [_vm._v("⅜")]), _vm._v("″ star tip, and pipe rows of butter along the long edges of the corresponding herb- and shrimp- buttered bread slices; chill to firm butters. Cut each bread slice crosswise into 5 rectangles. Garnish rectangles with capers, cooked shrimp slices, radishes, and chives.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("LOWCOUNTRY SHRIMP PASTE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 2"), _c('b', [_vm._v("½")]), _vm._v(" CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("A specialty of Charleston and the Carolina Lowcountry, this shrimp paste—similar to what the English call potted shrimp—is delicious spread on buttered toast.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. (2 sticks) unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. shrimp, peeled and deveined")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup sherry")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. cayenne pepper")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat 6 tbsp. butter in a large skillet until it is hot and foaming. Add the shrimp, salt, and black pepper and cook over high heat, stirring often, until the shrimp are pink and cooked through, 4–7 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Remove the skillet from the stove and use a slotted spoon to transfer the cooked shrimp to a food processor. Return the skillet to the stove and add sherry, lemon juice, and cayenne. Cook over high heat until the liquid in the skillet is reduced to about 3 tbsp. and is quite syrupy. Immediately add this to the shrimp in the food processor and process until the shrimp are thoroughly puréed. Cut remaining 10 tbsp. butter into pieces. With the motor running, add the butter, a few pieces at a time, and process until thoroughly blended. Turn the food processor off and taste the shrimp paste for seasoning, adding more salt, black pepper, sherry, lemon juice, or cayenne as needed. Transfer the shrimp paste to a crock or bowl and allow to cool completely. If not using right away, cover the shrimp paste and refrigerate for up to 1 week.")]), _vm._v(" "), _c('p', {
    staticClass: "line01"
  })]), _c('p', {
    staticClass: "center0"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("“One of the very nicest things about life is the way we must regularly stop whatever it is we are doing and devote our attention to eating.”"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUCIANO PAVAROTTI")])])])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "line02"
  }), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("DEVILS ON HORSEBACK")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("In this version of the classic hors d’oeuvre, oysters are cooked with garlic and wine, then set “astride” toasted garlic bread slices and sprinkled with bacon.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("tbsp. unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. finely chopped garlic")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("small baguette (about "), _c('b', [_vm._v("¼")]), _vm._v(" lb.), cut into eight 1″-thick slices")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("10")]), _c('td', [_vm._v("slices bacon, cut into 2″ pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("scallions, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup white wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. fresh lemon juice, plus wedges for serving")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("oysters, such as bluepoint, shucked, juices reserved"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. roughly chopped fresh flat-leaf parsley, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 400°. Melt 4 tbsp. butter in a small pan; mix with 1 tsp. garlic. Brush baguette slices with the garlic butter and arrange on a baking sheet. Bake until lightly toasted, about 10 minutes. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Meanwhile, cook bacon in a 12″ skillet over medium-high heat until crispy, about 10 minutes. Using a slotted spoon, transfer bacon to paper towels to drain, reserving bacon fat for another use; set aside. Heat remaining 2 tbsp. butter in the skillet. Add remaining 5 tsp. garlic and the scallions and cook, stirring, until soft, about 3 minutes. Add wine, lemon juice, oysters with their juices, and salt and pepper. Cook, stirring, until oysters begin to curl at the edges, about 3 minutes. Using a slotted spoon, transfer oysters to a bowl; cover to keep warm. Continue to cook sauce until thickened and reduced by half, about 10 minutes. Divide oysters and sauce among baguette slices; top with reserved bacon and garnish with parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("FRIED ARTICHOKE HEARTS WITH TAHINI SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Ardî Shawkî Maqli bil-Taratur")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("We found this recipe—a flavorful preparation, in which tender artichoke bottoms are fried and served with an intense, tahini-based sauce—at al-Az, a casual but well-known restaurant in Damascus.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE TAHINI SAUCE")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("cloves garlic, peeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup tahini")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tsp. chopped fresh flat-leaf parsley")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE ARTICHOKES")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cups olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("hearts of steamed medium artichokes, halved if large")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup flour"), _c('br'), _vm._v("Kosher salt, to taste")])])])])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the sauce: Combine garlic and salt in a mortar and grind to a paste with pestle. (Garlic can also be very finely chopped.) Transfer garlic paste to a bowl and add tahini. While stirring, drizzle in lemon juice. Thin to the consistency of a thick dip with up to 3 tbsp. water. Stir in 2 tsp. parsley.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat oil in a medium saucepan over medium-high heat until a deep-fry thermometer reads 375°. Dredge artichokes in flour and shake off excess. Fry artichokes, a few at a time, turning occasionally, until golden, about 2 minutes. Remove with a slotted spoon, drain on paper towels, and sprinkle with salt. Serve with sauce, garnished with remaining 1 tsp. parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" To test if the oil is hot enough, drop in a toothpick. If it quickly turns dark brown, the oil is ready.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("LEMON & CORIANDER MARINATED OLIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Elies Tsakkistes me Koliandro")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 8–10")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Chunks of lemon and cracked coriander seeds lend a bright flavor to these classic Greek-style olives.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("cups cracked (but not pitted) green olives")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. cracked whole coriander seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cloves garlic, smashed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("fresh or dried bay leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lemon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" In a large bowl, mix olives with oil, lemon juice, coriander, garlic, and bay leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Cut lemon into wedges lengthwise; cut each wedge crosswise into "), _c('b', [_vm._v("½")]), _vm._v("″-thick pieces. Add lemon pieces to olives; stir well to combine. Cover olives with plastic wrap and refrigerate for at least 8 hours or up to 1 month. Bring olives to room temperature before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" When making this dish, we prefer to use the nutty, cracked Cypriot olives called "), _c('i', [_vm._v("kipriakes eliés,")]), _vm._v(" but you can use Italian "), _c('i', [_vm._v("Cerignola")]), _vm._v(" or Spanish "), _c('i', [_vm._v("Gordal")]), _vm._v(" olives and get equally good results.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("FRIED OLIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 2")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Briny olives take on a whole new dimension when fried in a crisp bread crumb crust. They’re a perfect cocktail party snack.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _c('td', [_vm._v("Olive oil, for frying")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("egg, beaten")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup fine dry bread crumbs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup pitted green olives, drained")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Pour oil to a depth of 2″ into a 2-qt. saucepan and heat over medium-high heat until a deep-fry thermometer reads 350°.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Meanwhile, place the beaten egg and the bread crumbs in separate bowls. Coat olives in egg, then roll in bread crumbs until fully coated. Fry one-quarter of the olives until golden, about 45 seconds. Drain on paper towels and repeat with remaining olives. Serve warm.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("EGGPLANT CAPONATA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This classic Sicilian dish of fried eggplant sops up the flavors of onions, celery, tomatoes, olives, raisins, capers, basil, pine nuts, and chocolate—yes, chocolate. It’s the perfect example of sweet and salty marrying well together.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("cups olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("lb. eggplant, cut into 1″ cubes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("large yellow onion, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("rib celery, roughly chopped"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. tomato paste, thinned with "), _c('b', [_vm._v("¼")]), _vm._v(" cup water")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup canned whole, peeled tomatoes, crushed by hand")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cups green olives, pitted and roughly chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup white wine vinegar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup golden raisins")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup salt-packed capers, rinsed and drained")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. finely grated unsweetened chocolate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup finely chopped fresh basil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. pine nuts")])])])])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oil in a 12″ skillet over medium-high heat. Working in batches, add eggplant and fry, tossing occasionally, until browned, 3–4 minutes. Using a slotted spoon, transfer eggplant to a large bowl; set aside.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Pour off all but "), _c('b', [_vm._v("¼")]), _vm._v(" cup oil and reserve for another use. Return skillet to heat, add onions and celery, and season with salt and pepper. Cook, stirring often, until beginning to brown, 10 minutes. Reduce heat to medium, add tomato paste, and cook, stirring, until caramelized and almost evaporated, 1–2 minutes. Add crushed tomatoes and continue cooking for 10 minutes. Stir in olives, vinegar, raisins, capers, sugar, and chocolate and cook, stirring occasionally, until thickened, about 15 minutes. Transfer to bowl with eggplant, along with basil and pine nuts, and mix together. Season with salt and pepper and let cool to room temperature before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("POTATO SKORDALIA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 2 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This garlicky purée of olive oil, almonds, and potatoes is a staple in a Greek mezze spread. It’s traditionally served with bread and raw vegetables.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("medium russet potato, peeled and cut into 1″ cubes"), _c('br'), _vm._v("Kosher salt, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup ground blanched almonds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("cloves garlic, smashed and minced into a paste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. red wine vinegar")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put potatoes into a 2-qt. saucepan and add enough salted water to cover by 1″. Bring to a boil and cook until tender, about 15 minutes. Drain and transfer to a bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Mash potatoes until smooth; stir in almonds and garlic. Add oil, then vinegar, in a thin stream while whisking vigorously, and season with salt. Skordalia will keep, refrigerated and covered, for up to 4 days.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("HERBED TOMATO TART")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 12–16")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Made with ripe cherry tomatoes and fragrant herbs, this sweet-savory tart makes a regular appearance during the annual midsummer communal feast held in the hilltop town of Buggiano, in northern Tuscany.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("9″×11″ sheets frozen puff pastry, thawed and chilled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup grated Parmigiano-Reggiano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("12")]), _c('td', [_vm._v("oil-packed anchovy filets, drained and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("lb. cherry or grape tomatoes"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. finely chopped fresh chives")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. finely chopped fresh oregano"), _c('br'), _vm._v("Freshly grated nutmeg, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 375°. Fit pastry sheets side by side in a parchment paper–lined 13″×18″ rimmed baking pan, pressing pastry against bottom and sides. Trim inner edges of pastry sheets so that they form a seam in center; trim pastry hanging over sides of pan. Prick bottom of pastry with a fork. Line bottom and sides of pastry with parchment paper and fill with pie weights or dried beans. Bake until edges of tart are golden, about 25 minutes. Remove weights and parchment, sprinkle Parmigiano over tart shell, and bake until cheese is melted and tart shell is golden all over, 15–20 minutes. Transfer to a rack and let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Arrange an oven rack 4″ from broiler and heat broiler. In a large bowl, mix together oil and anchovies; add tomatoes and season with salt and pepper. Toss to coat. Transfer tomato mixture to a baking sheet and broil, shaking pan once or twice, until tomatoes blister, 12–14 minutes. Let cool slightly. Use a slotted spoon to transfer tomato mixture to the prepared tart shell; distribute tomatoes evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat oven to 425°. In a medium bowl, mix parsley, chives, oregano, and nutmeg; sprinkle herb mixture evenly over tomatoes. Return tart to oven and bake until hot, about 15 minutes. Let tart cool slightly before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("PISSALADIÈRE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Caramelized Onion Tart")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 12")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This southern French tart takes its name from "), _c('i', [_vm._v("pissala,")]), _vm._v(" a pungent anchovy paste that gives the flatbread its distinctive flavor. Serve this savory bread as an appetizer or as a snack, served with a glass of rosé.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("1")])]), _c('td', [_c('b', [_vm._v("¼")]), _vm._v("-oz. package active dry yeast")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup water, heated to 115°")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("cups flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup extra-virgin olive oil, plus more for greasing")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. kosher salt, plus more to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("20")]), _c('td', [_vm._v("oil-packed anchovy filets, drained and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("12")]), _c('td', [_vm._v("medium yellow onions, thinly sliced lengthwise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("sprigs fresh thyme")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("sprigs fresh rosemary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("bay leaves"), _c('br'), _vm._v("Freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup pitted, halved black olives")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the dough: Whisk together yeast and water in a large bowl; let sit until foamy, about 10 minutes. Add flour, "), _c('b', [_vm._v("¼")]), _vm._v(" cup oil, and salt and stir until dough forms; transfer to a floured work surface and knead until smooth, about 6 minutes. Transfer to a greased bowl, cover with plastic wrap, and let sit in a warm spot until doubled in size, about 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Meanwhile, make the topping: Heat remaining "), _c('b', [_vm._v("½")]), _vm._v(" cup oil in a 6-qt. saucepan over medium-low heat. Add anchovies and cook, stirring, until dissolved in the oil, about 7 minutes. Add onions, thyme, rosemary, bay leaves, and salt and pepper and cook, covered and stirring occasionally, until reduced and softened, about 1 hour. Uncover and cook, stirring occasionally, until liquid evaporates and onions are golden brown, about 30 minutes. Remove from heat and discard herb sprigs and bay leaves; let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat oven to 425°. Uncover dough and transfer to a work surface; using a rolling pin, roll dough into a 12″×18″ rectangle. Transfer dough rectangle to a greased 13″×18″ rimmed baking sheet and then cover evenly with onion mixture; place olive halves decoratively over onion mixture. Cover tart loosely with plastic wrap and let sit until dough is puffed, about 1 hour. Bake until golden brown at the edges, about 20 minutes. Let cool for 10 minutes before cutting into squares to serve.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("TREVISO & GORGONZOLA TART")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Treviso, the long-leaved cousin of round Verona radicchio, is wilted and tossed with blue cheese as a topping for this light and crispy tart.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("7"), _c('b', [_vm._v("½")]), _vm._v("″×14"), _c('b', [_vm._v("½")]), _vm._v("″ sheet frozen puff pastry, thawed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic, crushed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("heads Treviso radicchio, cored and coarsely chopped"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("oz. Gorgonzola cheese, crumbled")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put a pizza stone on oven rack set in middle of oven. Heat oven to 400°.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat 3 tbsp. oil in a large skillet over medium heat, add garlic, and cook until golden, 3–4 minutes. Add radicchio, raise heat to medium-high, and cook until wilted, 2–3 minutes. Season with salt and pepper. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Place a pastry sheet on a floured inverted baking sheet, prick all over with a fork, then scatter radicchio and Gorgonzola on top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Put into freezer for 15 minutes, then loosen pastry from baking sheet with a metal spatula and slide onto pizza stone. Bake until pastry is golden, 18–20 minutes. Let cool for 5–10 minutes before cutting into squares to serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak1"
  }, [_c('br')])]), _c('h2', [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "a5"
    }
  }, [_c('i', [_vm._v("Dips & Spreads")])])]), _c('a', {
    attrs: {
      "id": "a5"
    }
  }, [_c('p', {
    staticClass: "line"
  })]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('b', [_vm._v("LEMON PARMESAN DIP")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 2 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Cheesy and bright-tasting, this crudité dip also makes a great salad dressing.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup grated Parmigiano-Reggiano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. Dijon mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic, mashed to a paste Grated zest of 1 lemon"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Stir all ingredients together in a bowl until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("FETA CHEESE SPREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 1 CUP")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("In this Greek recipe, feta is blended with olive oil and red chiles into a savory spread. It’s delicious right away, but it’s even better when left to marinate for several hours so the flavors can blend.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. feta, crumbled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil, plus more as needed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("small dried red chiles"), _c('br'), _vm._v("Freshly ground black pepper, to taste"), _c('br'), _vm._v("Juice of "), _c('b', [_vm._v("½")]), _vm._v(" lemon"), _c('br'), _vm._v("Kalamata olives, for serving"), _c('br'), _vm._v("Pita bread, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Combine feta, oil, chiles, a few grinds of pepper, and lemon juice in a food processor and blend until very smooth. Transfer to a bowl. Cover and refrigerate for several hours so that the flavors develop and the cheese spread sets up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Bring to room temperature. Drizzle a little oil over the top. Serve with olives and pita. Spread will keep, refrigerated, for up to 1 week.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("MAYTAG BLUE CHEESE DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 2 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("The most celebrated American blue cheese, Maytag Blue—made on a dairy farm in Newton, Iowa, and cave-aged for six months for a full, rich flavor—is available in quality cheese shops. Other blue cheeses may be substituted, but Maytag is worth looking for. Celery sticks make an ideal vehicle for this rich dip.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("oz. cream cheese, softened")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup sour cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup heavy cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. Maytag Blue cheese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("scallions, chopped"), _c('br'), _vm._v("Freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Mix cream cheese, sour cream, and heavy cream together in a medium bowl. Crumble in blue cheese, add two-thirds of the scallions, and stir until well mixed but still slightly chunky. Season to taste with pepper and garnish with remaining scallions.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("ARTICHOKE DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 3 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Artichokes mixed with salty parmesan cheese and creamy mayo are baked together until bubbling hot. This quintessential appetizer is served all across the South, from New Orleans, Louisiana, to Norfolk, Virginia.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3–4")]), _c('td', [_vm._v("cups cooked artichoke hearts, or one 15-oz. can artichoke hearts, drained and chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup grated Parmigiano-Reggiano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup mayonnaise"), _c('br'), _vm._v("Minced onions, to taste"), _c('br'), _vm._v("Assorted crackers, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Heat oven to 350°. Combine artichokes, cheese, and mayonnaise, mixing well. Stir in onions to taste. Spoon into an 8″ square baking dish. Bake until bubbly and lightly browned. Serve with crackers.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  })]), _c('p', {
    staticClass: "center_s"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("RAW")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("DEAL")])])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "line2"
  })]), _c('div', {
    staticClass: "box1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "left_s1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("There’s nothing new about eating raw vegetables, but in the States it wasn’t until the first half of the 20th century that an austere serving of celery sticks was recast as crudités—an opulent appetizer. The distinction is partly semantic: Fashionable French restaurants in America offered first-course relish plates of raw vegetables, referring to them in their native tongue (the word "), _c('i', [_vm._v("crudité")]), _vm._v(" itself is French for “rawness,” though the presentation may include cooked or cured ingredients), and the term caught on. The definition is also an aesthetic one: Crudités live or die by their composition, by their balance of colors, and the allure of the arrangement. Whether it’s a single sliced carrot or a polychromatic cornucopia, it’s a dish that’s meant to attract, to be admired. (James Beard called crudités “the most appetizing dish imaginable.”) Compose your crudités using whatever looks best at the market: Broccoli, cauliflower, carrots, and cucumbers are just starting points; try wedges of raw fennel, elegant breakfast radishes, pickled caperberries, or blanched green beans, and always several dips, like ")]), _c('a', {
    attrs: {
      "href": "#/cap01#page_25"
    }
  }, [_vm._v("Lemon Parmesan Dip")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/cap01#page_28"
    }
  }, [_vm._v("Magical Muhammara")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/cap01#page_28B"
    }
  }, [_vm._v("Bagna Cauda")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("TAPÉNADE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES "), _c('b', [_vm._v("½")]), _vm._v(" CUP")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_c('i', [_vm._v("Tapénade")]), _vm._v(" speaks to salt lovers. Briny olives, salty capers, and anchovy filets are mixed into a piquant spread that’s brightened by the addition of lemon juice, parsley, and olive oil.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("oil-packed anchovy filet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. chopped, rinsed salt-packed capers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup chopped, pitted niçoise olives")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('b', [_vm._v("¼")])])]), _c('td', [_vm._v("cup extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. fresh lemon juice")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Crush garlic and anchovy filet with a mortar and pestle, then mix in capers, olives, and parsley. Stir in oil, add lemon juice, and combine well with a fork.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("FRENCH ONION DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 3"), _c('b', [_vm._v("½")]), _vm._v(" CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Our favorite recipe for this classic dip showcases onions three ways: fried, roasted, and fresh.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("medium yellow onions, 2 quartered lengthwise, 2 finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup olive oil"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("oz. cream cheese, softened")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup sour cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. Worcestershire sauce"), _c('br'), _vm._v("Tabasco sauce, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("scallions, minced"), _c('br'), _vm._v("Cut raw vegetables, such as cucumber, carrot, and cauliflower, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 425°. Toss quartered onions with 2 tbsp. oil on a foil-lined baking sheet, and season with salt and pepper. Roast, turning occasionally, until soft and slightly caramelized, about 45 minutes. Set roasted onions aside to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Purée roasted onions in a food processor until smooth. Add mayonnaise, cream cheese, sour cream, lemon juice, Worcestershire, hot sauce, salt, and pepper, and purée until smooth. Transfer to a bowl, cover with plastic wrap, and refrigerate until set, at least 4 hours or up to overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat remaining oil in a 10″ skillet over medium-high heat. Add finely chopped onions and cook, stirring, until beginning to brown, about 10 minutes. Reduce heat to medium-low and cook, stirring occasionally, until deep golden brown, about 16 minutes more. Transfer onions to a sieve set over a bowl to drain; discard oil or reserve for another use. Transfer fried onions to paper towels to drain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" To serve, stir two-thirds of the fried onions and the scallions into dip, and transfer to a serving bowl. Top with remaining fried onions and serve with raw vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_28B"
    }
  }, [_c('b', [_vm._v("BAGNA CAUDA")])])]), _c('a', {
    attrs: {
      "id": "page_28B"
    }
  }, [_c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Anchovy & Garlic Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This lusty hot dip, whose Italian name means “warm bath,” provides the perfect counterpoint to raw vegetables.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("10")]), _c('td', [_vm._v("salt-cured anchovy filets, rinsed and finely chopped"), _c('br'), _vm._v("Kosher salt, to taste"), _c('br'), _vm._v("Cut raw cauliflower, carrots, celery, radicchio, and radishes, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oil and butter in a pot over medium-high heat until butter begins to foam. Add garlic and cook for 10 seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Reduce heat to medium-low and add anchovies. Cook, stirring and mashing anchovies with a wooden spoon, until anchovies are broken into very small pieces and dip is cloudy, 3–4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Season with salt and serve immediately with raw vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("GALILEAN-STYLE HUMMUS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Mashaushe")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 3 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Generous spice, a good dose of olive oil, and whole chickpeas piled high are the hallmarks of this Galilean-style hummus.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups dried chickpeas, soaked overnight and drained")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup tahini")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup extra-virgin olive oil, plus more")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. ground cumin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cloves garlic, peeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small red Thai chile, stemmed and seeded"), _c('br'), _vm._v("Kosher salt, to taste"), _c('br'), _c('span', {
    attrs: {
      "href": "#/cap11#page_446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pita Bread")]), _vm._v(" (or store-bought), for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Bring chickpeas and 4 cups water to a boil in a 4-qt. saucepan. Reduce heat to medium-low and cook, covered, until chickpeas are very tender, 1–1"), _c('b', [_vm._v("½")]), _vm._v(" hours. Drain, reserving "), _c('b', [_vm._v("½")]), _vm._v(" cup cooking liquid; cool to room temperature. Transfer all but "), _c('b', [_vm._v("¾")]), _vm._v(" cup chickpeas to a food processor with the tahini, oil, juice, cumin, garlic, chile, and salt; purée until smooth. Add reserved cooking liquid and continue to purée until airy in consistency, about 5 minutes. Transfer hummus to a serving dish. Top with remaining whole chickpeas, drizzle with more oil, and sprinkle with salt. Serve with pita bread.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("BABA GHANNOUJ")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Mashed Eggplant Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("The classic Middle Eastern eggplant spread, redolent of garlic and smoky charred eggplant, is made even creamier with the addition of a small quantity of mayonnaise.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("cloves garlic, unpeeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("medium eggplants")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup plus 2 tbsp. tahini")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tsp. finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. ground cumin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. paprika"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Heat broiler. Place garlic and eggplants on a foil-lined baking sheet and broil until tender and charred all over, about 10 minutes for garlic and 40 minutes for eggplant. Peel garlic and peel and seed eggplants. Mash eggplant flesh, garlic, lemon juice, tahini, mayonnaise, 2 tsp. parsley, the cumin, paprika, salt, and pepper in a bowl. Sprinkle with remaining 1 tsp. parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("LABNEH")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Thick, tart, and luscious, this yogurt-like cheese, when eaten together with olive oil, pita bread, and the sumac-based spice blend "), _c('i', [_vm._v("za’atar,")]), _vm._v(" makes a typical breakfast throughout the Middle East.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("cups whole milk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup plain yogurt"), _c('br'), _vm._v("Kosher salt, to taste"), _c('br'), _vm._v("Extra-virgin olive oil, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Bring milk just to a boil in a 4-qt. nonreactive saucepan fitted with a deep-fry thermometer. Remove from heat and let cool until thermometer reads 118°. Transfer 1 cup milk to a bowl and whisk in yogurt until combined. Add yogurt mixture to saucepan and whisk until smooth; cover tightly with plastic wrap and let sit at room temperature (70°–75°) until thickened, 6–8 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Line a fine-mesh sieve with 3 layers of cheesecloth and set over a bowl. Transfer mixture to sieve and let drain for at least 8 hours or up to overnight. Transfer to a serving dish. Season with salt and drizzle with oil.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_28B"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('b', [_vm._v("MAGICAL MUHAMMARA")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 2 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Diana Abu-Jaber, author of the book "), _c('i', [_vm._v("The Language of Baklava")]), _vm._v(", grew up with a Jordanian father who would lure his children back home by making their favorite foods. According to Abu-Jaber, “This dip or spread is good for when you want everyone to quit running around and come to the table.” Serve with warm pita bread, or use as a spread on your favorite sandwich.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("roasted red bell peppers, peeled, seeded, and chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups walnuts, toasted")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup dried bread crumbs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup extra-virgin olive oil, plus more for serving")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup tomato purée")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. unsweetened pomegranate juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. crushed red chile flakes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. ground cumin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground allspice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup chopped fresh flat-leaf parsley")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Combine all ingredients except parsley in a food processor or blender. Purée until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Spoon dip into small bowls and garnish with parsley. Cover and chill until ready to serve. Before serving, top with drizzle of oil.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SALSA DE PIÑA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Fresh Pineapple Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 5 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Pineapple’s bright flavor shines in this fragrant, spicy Mexican salsa. It’s a terrific foil for rich meats, stewed chicken, and roasted fish—or, on its own, as a brilliantly tart-sweet counterpoint to salty tortilla chips.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups finely chopped pineapple")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup finely chopped fresh cilantro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup fresh lime juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("serrano chiles, stemmed and minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small red onion, minced"), _c('br'), _vm._v("Tortilla chips, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Combine all ingredients in a large bowl and toss until evenly combined. Let sit at room temperature to meld flavors, at least 30 minutes. Serve with tortilla chips.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SALSA VERDE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Green Tomatillo Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 4 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Bright and fruity, this Mexican salsa is a perfect partner to rich cheesy dishes and grilled meats.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. tomatillos, husked and rinsed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cloves garlic, peeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("medium white onions, quartered")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("jalapeños, stemmed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("bunch cilantro, stemmed"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Combine tomatillos, garlic, onions, and jalapeños in a 4-qt. saucepan; add water to cover by 1″. Bring to a boil and cook until slightly soft, about 5 minutes. Drain, reserving 1 cup cooking liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Transfer to a blender along with reserved liquid, sugar, cilantro, and salt and pepper, and pulse until chunky. Transfer to a bowl and serve at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("OAXACAN SHRIMP PICO DE GALLO")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Salsa con Camarón Seco")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 3 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("In coastal Oaxaca, Mexico, dried shrimp appear in all kinds of preparations. Here, they bring texture and intense flavor to a classic "), _c('i', [_vm._v("pico de gallo")]), _vm._v("–style salsa.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. plum tomatoes, cored and roughly chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. Mexican dried shrimp, soaked overnight, drained, and roughly chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup roughly chopped pickled jalapeños, plus 2 tbsp. brine from jar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup roughly chopped fresh cilantro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("small white onion, roughly chopped"), _c('br'), _vm._v("Juice of 2 limes"), _c('br'), _vm._v("Kosher salt, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("In a large bowl, mix tomatoes, shrimp, jalapeños plus brine, cilantro, onion, lime juice, and salt. Let sit at room temperature to meld flavors, at least 1 hour.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('b', [_vm._v("TEX-MEX CHILE CON QUESO")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("You’ll find this creamy, cheesy dip on the menu at virtually every Tex-Mex restaurant in San Antonio, Texas, generally with a basket of tortilla chips.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup grated extra-sharp cheddar cheese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup Velveeta, cut into pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup heavy cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. chopped peeled yellow onion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. diced tomato")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("jalapeño, stemmed, seeded, and diced"), _c('br'), _vm._v("Tortilla chips, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put cheddar and Velveeta in a medium pot. Set it over a pot of simmering water over medium heat and heat until cheese mixture is nearly melted. Add cream and stir constantly with a wooden spoon until cheese mixture is hot and smooth, 3–5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Transfer cheese mixture to a serving dish and sprinkle onions, tomatoes, and jalapeños on top. Serve immediately with tortilla chips.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CASA DRAGONES GUACAMOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 4 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This guacamole, sourced from the Casa Dragones tequila-making operation in San Miguel de Allende, Mexico, offers a hit of flavor thanks to a rough paste made from white onion, cilantro, serrano chiles, and garlic, into which chunks of ripe avocado are gently incorporated.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped white onion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. minced fresh cilantro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("serrano chiles, stemmed, seeded, and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cloves garlic, minced"), _c('br'), _vm._v("Kosher salt, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("avocados, pitted, peeled, and cut into 1″ chunks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("plum tomato, seeded and finely chopped"), _c('br'), _vm._v("Juice of 1 lime"), _c('br'), _vm._v("Tortilla chips, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" In a large bowl or "), _c('i', [_vm._v("molcajete,")]), _vm._v(" combine onion, cilantro, chiles, and garlic; sprinkle heavily with salt and mash with a fork or pestle into a chunky paste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Add avocados, tomato, and lime juice and stir to combine, mashing some of the avocado slightly as you stir. Season with salt and serve with tortilla chips.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("GOAN AVOCADO SALAD")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 3"), _c('b', [_vm._v("½")]), _vm._v(" CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This dish, originally created by chef Floyd Cardoz for the Bread Bar at Manhattan’s now-closed Tabla restaurant, is guacamole gone happily Indian. It’s spiked with cayenne and cumin and served with naan chips.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE SALAD")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("avocados, pitted, peeled, and cut into "), _c('b', [_vm._v("½")]), _vm._v("″ pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small red onion, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("plum tomato, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. finely sliced fresh cilantro leaves, plus more for garnish")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. fresh lime juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1–2")]), _c('td', [_vm._v("tsp. ground cumin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅛")])]), _c('td', [_vm._v("tsp. cayenne pepper"), _c('br'), _vm._v("Fine sea salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE CHIPS")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("8″–9″ "), _c('span', {
    attrs: {
      "href": "#/cap11#page_447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("naan breads")]), _vm._v(" (or store-bought)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil"), _c('br'), _vm._v("Fine sea salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" To make the salad: Put all the ingredients, except the garnish, in a medium bowl and stir well. Press plastic wrap directly onto surface of salad and refrigerate for 2–3 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" To make the chips: Heat oven to 350°. Using a rolling pin, roll each naan "), _c('b', [_vm._v("⅛")]), _vm._v("″ thick. Cut each bread into 12 triangles. Put triangles into large bowl, drizzle with oil, add salt and pepper, and toss well. Arrange triangles in a single layer on a baking sheet. Bake until crisp, about 20 minutes, turning chips over and rotating baking sheet front to back after 10 minutes. Set aside to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Garnish salad with cilantro and serve with naan chips.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak1"
  }, [_c('br')])]), _c('h2', [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('i', [_vm._v("Snacks")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SCOTCH EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("A hard-cooked egg encased in sausage and bread crumbs and then deep-fried may seem like a product of modern pub culture, but the Scotch egg debuted at London department store Fortnum & Mason in 1738.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("eggs in their shells, plus 1 egg lightly beaten")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. pork sausage, casings removed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. English mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. cornstarch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. ground mace")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("leaves fresh sage, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("sprigs fresh thyme, finely chopped"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper"), _c('br'), _vm._v("Canola oil, for frying")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup milk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups panko bread crumbs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Place 6 eggs in a 2-qt. saucepan and cover by 1″ with cold water. Place over medium-high heat and bring to boil; cover, remove from heat, and let sit for 6 minutes. Drain eggs and transfer to a bowl of ice water; let sit for 5 minutes. Drain eggs and peel and discard shells; set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Combine sausage, Worcestershire, mustard, cornstarch, mace, and herbs in a bowl; season with salt and pepper and mix until evenly combined. Divide into 6 equal portions, and press a portion around each cooked egg to cover completely. Place on a plate and refrigerate for 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Pour oil to a depth of 2″ into a 6-qt. Dutch oven and heat over medium-high until a deep-fry thermometer reads 350°. Combine beaten egg and milk in a bowl, and place flour and bread crumbs in separate bowls. Working in batches, coat each meat-covered egg in flour, shaking off excess, and then dip in milk mixture to coat. Dredge in bread crumbs, and then fry until crumbs are golden brown and meat is cooked through, about 7 minutes. Transfer to paper towels to drain briefly, and let cool for 10 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CHINESE TEA EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Cha Ye Dan")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Cooked in a flavorful marinade of soy sauce, star anise, and cinnamon, these tea-stained eggs are a Lunar New Year staple and a favorite everyday snack in China.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup soy sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. black peppercorns")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. fennel seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("whole cloves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("star anise pods")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("sticks cinnamon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. loose-leaf smoked tea, such as"), _c('br'), _vm._v("Lapsang souchong")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("eggs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Combine soy sauce, sugar, peppercorns, fennel, cloves, star anise, cinnamon, and 2 cups water in a 2-qt. saucepan and bring to a boil; remove from heat and add tea. Let steep for 10 minutes, then pour marinade through a fine-mesh sieve into a bowl. Keep warm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Place eggs in a 4-qt. saucepan and cover by "), _c('b', [_vm._v("½")]), _vm._v("″ with cold water. Place saucepan over medium-high heat and bring to a boil; cover, remove from heat, and let sit until eggs are soft-boiled, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Drain eggs. Crack shells all over but do not peel eggs; return to saucepan along with marinade. Bring to a boil and cook, stirring, for 5 minutes. Remove from heat and add 2 cups ice. Let eggs cool in marinade before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CLASSIC DEVILED EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 24")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Deviled eggs come in a seeming infinity of variations, but originally, deviled foods got their name from the addition of an assertive ingredient, such as horseradish, chiles, or, in the case of this recipe, mustard and vinegar.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("12")])]), _c('td', [_vm._v("hard-cooked eggs (see "), _c('a', {
    attrs: {
      "href": "#/cap01#eggsPerfected"
    }
  }, [_vm._v("Eggs, Perfected")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. cider vinegar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. melted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. yellow mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. sugar"), _c('br'), _vm._v("Kosher salt, freshly ground black pepper, and paprika, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Gently peel eggs and halve each lengthwise. Remove yolk from each egg half and transfer to a large bowl. Arrange whites on a large platter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Mash yolks well with a fork, then add mayonnaise, vinegar, butter, mustard, sugar, and salt and pepper. Stir the egg yolk mixture until smooth. Using a small spoon, fill each egg white half with a rounded dollop of the egg yolk mixture. Loosely cover deviled eggs with plastic wrap and refrigerate until chilled. When ready to serve, sprinkle the eggs with paprika.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("DEVILED EGGS WITH SMOKED TROUT")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 24")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Deviled-egg enthusiast Carolynn Spence, chef at the Chateau Marmont in Los Angeles, shared her version of this classic hors d’oeuvre with us, which pairs the egg with smoked fish.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("12")]), _c('td', [_vm._v("hard-cooked eggs (see "), _c('a', {
    attrs: {
      "href": "#/cap01#eggsPerfected"
    }
  }, [_vm._v("Eggs, Perfected")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. dry mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. whole-grain mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. cayenne pepper"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup shredded smoked trout"), _c('br'), _vm._v("Smoked paprika, minced fresh chives, and thinly shaved red onion, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Gently peel eggs and halve each lengthwise. Remove yolk from each egg half and transfer to a fine sieve set over a bowl. Arrange whites on a large platter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Using a rubber spatula, press yolks through sieve. Add mayonnaise, oil, lemon juice, mustards, and cayenne. Season with salt and pepper and stir vigorously with spatula until smooth.")])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Transfer mixture to a piping bag fitted with a plain tip and pipe into egg whites. Top each egg with a bit of trout; garnish with smoked paprika, chives, and red onion. Serve cold or at room temperature.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "line1"
  })]), _c('p', {
    staticClass: "center_s"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "eggsPerfected"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("EGGS,")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("PERFECTED")])])])]), _c('a', {
    attrs: {
      "id": "eggsPerfected"
    }
  }, [_c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_vm._v("The best way to make perfect hard-boiled eggs is not to actually boil them. Arrange eggs in a single layer in a medium pot and cover with cold water by 1″. Bring to a boil over medium-high heat, then immediately remove pot from heat. Cover and let rest for 8–10 minutes undisturbed. Drain eggs, leaving them in the pot; tap the eggs with a spoon to crack their shells. This will allow water to seep under the shells, which helps with peeling. Cover eggs with cold water, swish around, then drain. Cover again, this time with icy-cold water (add a few ice cubes if necessary). As soon as the eggs are cool, peel them, starting at the broad end and holding the egg under running water to loosen any bits of stubborn shell clinging to the sides. The longer eggs sit without peeling, the more difficult they will be to peel.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SOUTHERN-STYLE DEVILED EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 24")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("The secret to these traditional Southern deviled eggs, from a recipe shared by home cook Sandra Livesay of Tarboro, North Carolina, is the addition of Durkee Famous Sauce (a tangy, vinegary sandwich spread) and sweet pickle relish.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("12")]), _c('td', [_vm._v("hard-cooked eggs (see "), _c('a', {
    attrs: {
      "href": "#/cap01#eggsPerfected"
    }
  }, [_vm._v("Eggs, Perfected")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tbsp. Durkee Famous Sauce, or 1 tbsp. each mayonnaise and Dijon mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. sweet pickle relish")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. paprika, plus more for garnish (optional)"), _c('br'), _vm._v("Kosher salt, freshly ground black pepper, and"), _c('br'), _vm._v("Tabasco sauce, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Gently peel eggs and halve each lengthwise. Remove yolk from each egg half and transfer to a medium bowl. Arrange whites on a large platter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Using a fork, mash yolks. Add Durkee sauce, relish, and paprika and season with salt, pepper, and Tabasco. Stir vigorously with rubber spatula until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Transfer mixture to a piping bag fitted with a plain tip and pipe into egg whites. Garnish eggs with more paprika, if you like. Serve cold or at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("AJI")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Persian Trail Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 5 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This traditional Iranian mixture of nuts, seeds, and dried fruits—often set out for snacking before or between meals—is an inspired mix of sweet and salty.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup roasted, salted pumpkin seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup salted whole pistachios")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup sugar-coated slivered almonds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅔")])]), _c('td', [_vm._v("cup dried mulberries")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup roasted, unsalted almonds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup dried, salted chickpeas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup golden raisins")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup dried currants")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("dried Mission figs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("dried Turkish figs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Stir together all ingredients in a bowl until evenly combined; store in an airtight container for up to 2 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SPICY FRIED PEANUTS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("In this Mexican bar snack, peanuts get a boost from the addition of ground dried Oaxacan "), _c('i', [_vm._v("chile de onza,")]), _vm._v(" hot and sweet, as well as tiny, whole dried "), _c('i', [_vm._v("chiles pequíns.")]), _vm._v(" Serve them alongside your best mezcal cocktail.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("dried chile de onza or chile de árbol")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. kosher salt"), _c('br'), _vm._v("Juice of 1 lemon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. skinned raw peanuts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("small cloves garlic, peeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. dried whole chiles pequíns, or 1 dried chile de árbol, chopped")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Toast chile de onza in a nonstick skillet over low heat. Discard stem, then grind chile with salt in a mortar and pestle. Add lemon juice, mix well, and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Toast peanuts and garlic in a skillet over low heat for about 5 minutes (shake pan to prevent burning). Add chiles pequíns and toast for 1 minute more. Transfer to a dish and drizzle chile-lemon mixture over peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SPICED PECANS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 2 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Fragrant, skillet-roasted pecans are a staple in the South during the holidays. These get their earthy, spicy savor from rosemary, smoked paprika, and chili powder.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tbsp. unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups pecan halves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. light brown sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. roughly chopped fresh rosemary leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. smoked paprika")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. chile powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. Tabasco sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. ground cinnamon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Melt butter in a 12″ skillet over medium heat. Add pecans and cook, swirling skillet constantly, until nuts are toasted, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Add brown sugar, rosemary, Worcestershire, paprika, chile powder, salt, Tabasco, black pepper, and cinnamon and stir until pecans are evenly coated. Continue cooking pecans, stirring constantly, until fragrant, 1–2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Transfer pecans to a parchment paper–lined baking sheet, spread into a single layer, and let cool, stirring pecans and breaking up sugar and spices occasionally.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("KHANDVI")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Spiced Chickpea-Flour Snacks")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("In this popular street snack from the Indian state of Gujarat, yogurt, ginger, chiles, and chickpea flour are whisked together to make a thick batter that’s rolled up into paper-thin coils and garnished with a riot of spices, seeds, and chiles.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE KHANDVI")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("serrano chiles, stemmed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("1″ piece ginger, peeled and minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup plain yogurt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup chickpea flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground turmeric")])])])])]), _c('p', {
    staticClass: "s_head0"
  }, [_c('a', {
    attrs: {
      "id": "eggsPerfected"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('b', [_vm._v("FOR THE GARNISH")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup peanut oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. black mustard seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. sesame seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("tsp. asafoetida")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("10")]), _c('td', [_vm._v("fresh or frozen curry leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("serrano chiles, stemmed and julienned")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("5")]), _c('td', [_vm._v("chiles de árbol")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. roughly chopped fresh cilantro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. freshly grated coconut")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the khandvi: Purée serranos, ginger, and "), _c('b', [_vm._v("¼")]), _vm._v(" cup water in a food processor until smooth; set paste aside. In a bowl, whisk together yogurt, flour, salt, turmeric, and 1 cup water. Whisk reserved paste into batter; transfer batter to a 4-qt. saucepan over medium-high heat. Whisking constantly, bring to a boil, then reduce heat to medium-low and cook until very thick, about 15 minutes. Spread the batter onto inverted baking sheets. Let cool, then slice into strips and roll into coils. (See Forming Khandvi, below, for illustrated step-by-step instructions.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the garnish: Heat oil in a 10″ skillet over high heat. Add mustard seeds, sesame seeds, asafoetida, curry leaves, serranos, and chiles de árbol and cook, stirring, until fragrant, about 2 minutes. To serve, pour garnish over roll-ups; sprinkle with cilantro and coconut.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" When you spread it out for rolling, the batter for this snack has to be of the right consistency—not too wet, not too dry—so test a spoonful of it on a plate first.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SOUR CREAM NACHOS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Nachos Agrios")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("We found these indulgent nachos at the San Antonio, Texas, eatery Los Barrios, where, with no false modesty, the menu called them “the most outstanding appetizer there is.”")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups refried beans")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("5–6")]), _c('td', [_vm._v("oz. tortilla chips")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup grated Swiss cheese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup grated provolone")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("jalapeño, stemmed, seeded, and diced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup sour cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. chopped, drained jarred pimientos")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 300°. Heat refried beans in a pan over medium heat until hot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Spread chips out evenly on a large oval ovenproof dish. Spread beans on top of chips, sprinkle cheeses evenly over beans, and scatter jalapeños over cheese. Bake until cheese is completely melted, about 5 minutes. Garnish with dollops of sour cream, then scatter pimientos over nachos. Serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("FORMING")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("KHANDVI")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("1")])]), _vm._v(" Arrange 2 baking sheets upside down. Spoon half the batter onto the side of one of the sheets. Using a spatula, spread batter toward far edge of sheet, creating an even layer.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("2")])]), _vm._v(" Let batter cool for 5 minutes. Using a paring knife, trim uneven edges of dried batter. Cut each sheet of batter into eight 5″×2″ strips.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("3")])]), _vm._v(" Roll up each strip of dried batter into a neat cylinder shape that’s about the size of a quarter in diameter. Transfer roll-ups to a platter.")])])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('b', [_vm._v("APPLE & STILTON WELSH RAREBIT BITES")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 24 BITES")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("To our minds, the classic “rabbit,” that creamy amalgam of cheddar and beer bearing a misleading name (the origins of which remain murky), is the pinnacle of cheese cookery. Pungent Stilton replaces the more traditional cheddar in this bite-size twist on the classic British dish.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("thin baguette, cut into "), _c('b', [_vm._v("½")]), _vm._v("″-thick slices")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. unsalted butter, melted")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small tart apple, such as Granny Smith, peeled, halved, cored, and thinly sliced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. crumbled Stilton or blue cheese, at room temperature")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. crème fraîche")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. Dijon mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. honey"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat a grill pan over medium-high heat. Brush baguette slices with melted butter; working in batches, grill, flipping once, until golden on both sides, about 2 minutes. Transfer to a parchment paper–lined baking sheet. Layer 2 apple slices on each toast; set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Arrange an oven rack 4″ from broiler and heat broiler. Mix cheese, crème fraîche, Worcestershire, mustard, honey, salt, and pepper in a small bowl. Spread about 1 tbsp. of the cheese mixture over each toast. Broil until topping is melted and golden brown, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("OVEN-DRIED SPICY PINEAPPLE SNACKS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 3 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Dressed in a flavor-bomb combination of sugar, salt, nutmeg, and hot chiles, chewy dried pineapple pieces make for an addictive cocktail snack. (We particularly love them alongside a gin and tonic.)")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("ripe pineapples, peeled, cored, and cut into "), _c('b', [_vm._v("¾")]), _vm._v("″–1″ chunks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup demerara sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. flaky sea salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. freshly grated nutmeg")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("Thai chiles, stemmed, seeded, and finely chopped Grated zest of 2 limes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 225°. Divide pineapple chunks between 2 large baking sheets and spread out in a single layer. Bake, rotating pans front to back and flipping pineapple chunks halfway through, until chunks are light golden brown and dried around the edges but still juicy in the center, about 4"), _c('b', [_vm._v("½")]), _vm._v(" hours. Transfer pans to a cooling rack; let pineapple cool to room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Put sugar, salt, nutmeg, chiles, and zest into a medium bowl and stir to combine. Add pineapple and toss to coat. Transfer to a serving bowl and serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" You may also leave the pineapple overnight in a gas oven, turned off; the heat from the pilot light will dry the fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak1"
  }, [_c('br')])]), _c('h2', [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "a7"
    }
  }, [_c('i', [_vm._v("Small Dishes")])])]), _c('a', {
    attrs: {
      "id": "a7"
    }
  }, [_c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("PEPPERS STUFFED WITH FETA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Piperies Gemistes me Feta")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4-6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("You might find peppers stuffed with cheese in a taverna in Athens or in other parts of Greece, but this classic mezze is associated above all with the region of Macedonia, in the north. Peppers—mild and hot, fresh and dried—are one of the agricultural glories of the region, and the queen of them all is the sweet, firm-fleshed, long red pepper grown around the town of Florina, in the mountains of Macedonia’s far northwest. Florina peppers can be hard to find in the States; Fresno or (if you like a bit of spice) Anaheim chiles are acceptable substitutes.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("10")]), _c('td', [_vm._v("3″–4″ Fresno chiles or six 4″–5″ Anaheim chiles")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("9")]), _c('td', [_vm._v("oz. feta, crumbled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. Greek yogurt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. minced fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. grated lemon zest")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. dried oregano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("egg yolks"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup grated Parmigiano-Reggiano cheese")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Arrange an oven rack 6″ from broiler and heat broiler. Put peppers on a baking sheet and broil, turning once, until just soft, about 5 minutes. Transfer to a rack; let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" In a large bowl, use a hand mixer to whip feta, oil, yogurt, parsley, lemon zest, oregano, and egg yolks; season with salt and pepper. Make a lengthwise cut from the stem to the tip of each pepper; scoop out seeds and ribs. Stuff each pepper with some of the feta filling and transfer to a foil-lined baking sheet; chill for 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Sprinkle peppers with grated cheese. Broil peppers until cheese is golden brown and bubbly, about 6 minutes. Transfer peppers to a platter and serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CHAWANMUSHI")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Japanese Egg Custard")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This tender egg custard reveals treasures upon digging in: succulent morsels of chicken and shrimp. The name translates to “steamed in a teacup,” but ramekins will do.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("iriko (Japanese-style dried anchovies), heads removed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("2″×15″ piece kombu (dried kelp)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. dried bonito flakes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("boneless, skinless chicken breast, cut crosswise into slices "), _c('b', [_vm._v("½")]), _vm._v("″ thick and 1"), _c('b', [_vm._v("½")]), _vm._v("″ long")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("medium shrimp, peeled, deveined, and halved lengthwise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. soy sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. mirin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("eggs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("shiitake mushrooms, stemmed and cut into 2 triangles each")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("fresh flat-leaf parsley leaves"), _c('br'), _vm._v("Grated zest of "), _c('b', [_vm._v("½")]), _vm._v(" lemon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Bring anchovies, kombu, and 1"), _c('b', [_vm._v("½")]), _vm._v(" cups water to a boil in a 4-qt. saucepan; remove and discard anchovies and kombu with a slotted spoon. Add bonito. Remove from heat, and let steep for 5 minutes. Pour through a sieve and set dashi aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat oven to 325°. Bring a large pot of salted water to a boil over high heat. Add chicken and cook until opaque, about 3 minutes. Using a slotted spoon, transfer to a bowl; set aside. Add shrimp and cook until opaque, about 30 seconds. Drain and add to bowl with chicken. Divide mixture among four 6-oz. ramekins and place in a 9″×13″ baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Whisk dashi, soy sauce, mirin, and eggs in a bowl and pour through a fine-mesh sieve into a liquid measuring cup. Pour over shrimp and chicken in ramekins and top with mushroom triangle. Pour boiling water into baking dish to come halfway up sides of ramekins. Bake until custard is just set, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Divide parsley among custard tops and continue cooking until parsley is slightly wilted, about 2 minutes. Remove from oven and transfer ramekins to serving plates; sprinkle with lemon zest before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" Keep the water bath simmering, never boiling, to ensure a smooth, crater-free surface on the custards.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  })]), _c('p', {
    staticClass: "center_s"
  }, [_c('a', {
    attrs: {
      "id": "a7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("THE CULTURE")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("OF TAPAS")])])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "line2"
  })]), _c('div', {
    staticClass: "box1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "left_s1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Arguing about the evolution of tapas is a favorite Spanish pastime. But this much is beyond dispute: Spain’s iconic little plates have a long history. One story is that the 13th-century Castilian king Alfonso X was instructed by his doctor to eat several mini-meals a day with wine; hence, tapas. Cervantes, in his 17th-century classic "), _c('i', [_vm._v("Don Quijote")]), _vm._v(", refers to "), _c('i', [_vm._v("llamativos")]), _vm._v(", or “lures”—tidbits designed to arouse hunger or thirst. However, the most commonly accepted theory is that tapas as we know them originated in Andalusia in the 19th century as small saucers set over wineglasses in taverns to keep the aroma in. Today, there are more than a thousand varieties of tapas, and every region, city, and bar in Spain has its own specialties, from baked scallops in Galicia to stuffed peppers in San Sebastián to Casa Bigote’s cod. But on almost every tapas menu you’ll find a variation of four essential recipes: ")]), _c('a', {
    attrs: {
      "href": "#/cap01#panTomate"
    }
  }, [_vm._v("Pan con Tomate")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/cap01#spanishMeatballs"
    }
  }, [_vm._v("Albóndigas en Salsa")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/cap01#page_37"
    }
  }, [_vm._v("Patatas Bravas")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/cap01#page_37T"
    }
  }, [_vm._v("Tortilla Española con Fritas")]), _vm._v(", the pillars—and, as Spanish tapas have become a global phenomenon, the ambassadors—of the genre.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "panTomate"
    }
  }, [_c('b', [_vm._v("PAN CON TOMATE")])])]), _c('a', {
    attrs: {
      "id": "panTomate"
    }
  }, [_c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Spanish-Style Toast with Tomato")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 2")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This utterly essential Spanish dish, emblematic of Barcelona’s tapas tradition but found throughout the country, is simplicity at its best. The pulp from a ripe tomato is spooned over garlic-rubbed bread and seasoned with sea salt.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("6″ piece baguette, halved lengthwise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("very ripe large tomato"), _c('br'), _vm._v("Coarse sea salt, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 500°. Put bread, cut side up, on a baking sheet and toast until golden brown, about 8 minutes. Rub garlic over cut surface and drizzle with oil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Put a box grater into a large bowl and grate tomato over largest holes, discarding skin. Spoon grated tomato onto warm toast and sprinkle with sea salt. Serve immediately.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "panTomate"
    }
  }), _c('a', {
    attrs: {
      "id": "spanishMeatballs"
    }
  }, [_c('b', [_vm._v("SPANISH-STYLE MEATBALLS")])])]), _c('a', {
    attrs: {
      "id": "spanishMeatballs"
    }
  }, [_c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Albóndigas en Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("These saucy meatballs figure in a wide range of dishes that make up the constellation of little snacks served in tapas bars all over Spain. Pick them up and pop them into your mouth with toothpicks—at some tapas bars, the discarded picks are tallied up so that the bar owner can compile the bill at the end of meal.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE MEATBALLS")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. coarsely ground beef")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. coarsely ground pork")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup fresh white bread crumbs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("eggs, lightly beaten")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cloves garlic, finely chopped"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup Spanish olive oil")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE SAUCE")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("large yellow onion, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("large leek, white part only, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("bay leaf")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups beef stock")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups dry white wine")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the meatballs: Mix together the beef, pork, bread crumbs, parsley, eggs, garlic, and salt and pepper in a large bowl. Chill for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Put flour into a bowl. Using wet hands, form meat mixture into 20 even-size meatballs. Roll each in flour, shaking off excess; transfer to a baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat half the oil in a large skillet over medium-high heat. Brown half the meatballs in the skillet, 10–12 minutes. Transfer meatballs to a plate. Wipe out skillet and repeat with remaining oil and meatballs, leaving oil and caramelized bits in skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Make the sauce: Heat skillet (with reserved oil) over medium-low heat. Add garlic, onion, leeks, and bay leaf and cook until softened, 12–15 minutes. Add flour and cook for 2 minutes. Whisk in stock and wine, raise heat to medium-high, and bring to a boil while whisking constantly. Reduce heat to medium-low and simmer until thickened, 12–14 minutes. Let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("5")]), _vm._v(" Discard bay leaf and purée sauce in blender in batches. Return sauce to skillet along with meatballs; bring to a boil over medium-high heat. Reduce heat to medium-low and simmer until thickened and meatballs are cooked, 16–18 minutes. Season with salt and pepper.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "spanishMeatballs"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('b', [_vm._v("PATATAS BRAVAS")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Fried Potatoes with Spicy Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 2")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Invented at the Madrid restaurant Vinícola Aurora in the 1950s, these “fierce potatoes”—crisp on the outside and melting on the inside, served with a fiery tomato sauce and a rich, garlicky "), _c('i', [_vm._v("allioli—")]), _vm._v("are now a staple on tapas menus throughout Spain and beyond. The key to this particular version is poaching and then frying the potatoes in olive oil.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE SALSA BRAVA")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup crushed canned tomatoes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. red wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. hot smoked paprika")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("serrano chile, stemmed and minced"), _c('br'), _vm._v("Kosher salt, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE ALLIOLI")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("egg yolk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("tbsp. olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. milk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE POTATOES")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _c('td', [_vm._v("Olive oil, for frying")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("russet potatoes, peeled and quartered")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the salsa brava: Purée tomatoes, oil, wine, paprika, sugar, and chile in a blender. Season with salt, transfer to a bowl, and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the allioli: Vigorously whisk egg yolk and garlic. While whisking, add 1 tbsp. oil in a thin stream until mixture thickens. Continue whisking, adding remaining 7 tbsp. oil in a thin stream. Add lemon juice and milk and season with salt; chill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Make the potatoes: Pour oil to a depth of 1"), _c('b', [_vm._v("½")]), _vm._v("″ into a 5-qt. pot and heat over medium heat until a deep-fry thermometer reads 220°. Transfer potatoes to oil and cook, turning occasionally, until tender and pale golden, 15–20 minutes. Using a slotted spoon, transfer potatoes to paper towels; chill. Remove pot from heat; reserve.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Heat reserved oil over medium-high heat until a deep-fry thermometer reads 350°. Add potatoes and cook until golden brown, 3–5 minutes. Transfer to paper towels and season with salt. Serve potatoes with the reserved brava salsa and allioli.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37T"
    }
  }, [_c('b', [_vm._v("TORTILLA ESPAÑOLA CON FRITAS")])])]), _c('a', {
    attrs: {
      "id": "page_37T"
    }
  }, [_c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Spanish Potato-Chip Omelette")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_c('i', [_vm._v("Tortilla española")]), _vm._v(" is everything we love about Spanish cooking—lusty, elemental, assuredly straightforward. Traditionally this Iberian omelette gets its heft from thin-sliced potatoes, but the version from inventive chef Ferran Adrià proposes an audacious update. Eschewing the dirty work of peeling, slicing, and frying the potato, Adrià substitutes a generous handful of store-bought thick-cut potato chips, which soften to just the right tenderness thanks to a soak in the beaten egg before the omelette is cooked.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("oz. thick-cut potato chips, gently crushed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("oz. serrano ham or prosciutto, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped canned piquillo peppers or pimientos")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. fresh thyme leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("eggs, lightly beaten"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. olive oil")])])])])]), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_37T"
    }
  }, [_vm._v("Heat broiler. Combine potato chips, ham, peppers, thyme, eggs, and salt and black pepper in a bowl and let sit to allow chips to soften in eggs, about 5 minutes. Heat oil in ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("a 10″ nonstick skillet over medium-high heat; add egg mixture and cook, without stirring, until bottom begins to brown, about 3 minutes. Transfer to broiler and broil until set and golden on top, about 3 minutes. Cut into wedges to serve.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("RAZOR CLAMS WITH CHILES & GARLIC")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Navajas al Ajillo")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 2–4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("With their long, narrow shells, razor clams are undeniably dramatic on the plate. Their sweet meat takes well to quick-cooked preparations like this fiery sauté of wine, garlic, and chiles. It’s a popular order at Bar Pinotxo, a revered tapas counter in La Boqueria, Barcelona’s covered market.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("5")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cloves garlic, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3–4")]), _c('td', [_vm._v("dried chiles de árbol, crumbled, or 2 tsp. red chile flakes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lbs. razor clams, rinsed thoroughly")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup white wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups loosely packed fresh flat-leaf parsley leaves, minced"), _c('br'), _vm._v("Kosher salt, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Heat oil, garlic, and chiles in a 12″ skillet over medium heat. Cook, swirling pan occasionally, until garlic is pale golden brown, about 6 minutes. Increase heat to high, add razor clams and wine, and cook, covered, until clams are just cooked through, about 3 minutes. Add parsley and season with salt; toss razor clams to coat with sauce. Transfer clams to a serving platter and drizzle with remaining sauce. Discard any clams that do not open.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("RICOTTA & ROASTED PEPPER FRITTATA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Frittata con Ricotta & Peperoni")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Calabrians in Italy sometimes add sliced cured sausage to this popular frittata on Easter, to celebrate the end of Lent. It makes a welcome addition to a meal of small plates or as a main course for brunch.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup grated pecorino romano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. roughly chopped fresh flat-leaf parsley leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. chopped fresh oregano")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("eggs, beaten"), _c('br'), _vm._v("Freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("large onion, halved and thinly sliced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small Yukon gold potato, peeled and sliced into "), _c('b', [_vm._v("⅛")]), _vm._v("″ rounds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("red bell pepper, roasted, peeled, seeded, and cut into "), _c('b', [_vm._v("¼")]), _vm._v("″-wide strips")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup ricotta")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 425°. In a large bowl, whisk together "), _c('b', [_vm._v("¼")]), _vm._v(" cup pecorino, parsley, "), _c('b', [_vm._v("½")]), _vm._v(" tsp. salt, oregano, and eggs and season with pepper. Set egg mixture aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat oil in a 10″ nonstick ovenproof skillet over medium-high heat. Add remaining 1 tsp. salt, onions, and potatoes and cook, stirring occasionally, until lightly browned and soft, about 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Remove skillet from heat. Add egg mixture to skillet and stir to distribute onion and potatoes evenly. Scatter peppers over top, spoon ricotta over mixture in 6 dollops, and sprinkle with remaining "), _c('b', [_vm._v("¼")]), _vm._v(" cup pecorino. Bake until lightly browned and set in center, about 15 minutes. Run a rubber spatula around edges of frittata to loosen it. Slide frittata onto a serving plate. Season with more pepper, if you like.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("NIÇOISE SALAD QUICHE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6–8")])])]), _c('p', {
    staticClass: "r_para"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("A nod to the ")]), _c('a', {
    attrs: {
      "href": "#/cap02#nicoiseSalad"
    }
  }, [_vm._v("composed salad of southern France")]), _vm._v(", this elegant quiche combines green beans, olives, potatoes, tuna, and just-wilted butter lettuce.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("medium Yukon gold potato, peeled and sliced "), _c('b', [_vm._v("¼")]), _vm._v("″ thick"), _c('br'), _vm._v("Kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("7")]), _c('td', [_vm._v("green beans, trimmed and cut into 1″ pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("head butter lettuce, trimmed and torn into 1″ pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("3-oz. can water-packed tuna; drained")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup heavy cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup milk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. Dijon mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("eggs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("oil-packed anchovy filet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic, peeled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small shallot, peeled"), _c('br'), _vm._v("Freshly ground black pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("recipe "), _c('span', {
    attrs: {
      "href": "#/cap12#quicheCrust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfect Quiche Crust")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("plum tomato, thinly sliced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('b', [_vm._v("½")])])]), _c('td', [_vm._v("cup pitted niçoise olives"), _c('br'), _vm._v("Finely chopped fresh flat-leaf parsley, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Boil potatoes in a 2-qt. pot of salted water until tender, 6–8 minutes. Add green beans and cook for 1 minute more. Using a slotted spoon, transfer vegetables to a bowl of ice water until cold; drain and place in a bowl. Add lettuce and tuna; set salad aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Purée cream, milk, oil, mustard, eggs, anchovy, garlic, and shallot. Season with salt and pepper, pour over salad, and gently stir to combine. Refrigerate filling until ready to use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Preheat oven to 325°. Spread filling evenly into crust, arrange tomatoes and olives over top, and bake until filling is set, about 20 minutes. Let quiche cool briefly, garnish with parsley, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("BEEF & BULGUR WHEAT MEATBALLS")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Kibbeh")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES 16")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Middle Eastern "), _c('i', [_vm._v("kibbeh")]), _vm._v(" is a finely ground paste of bulgur, onions, and lamb or beef, which is formed into patties or balls, filled with coarsely ground, sweetly spiced meat, onions, and pine nuts, and deep-fried.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE FILLING")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil, plus more for garnish")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("medium onion, roughly chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. ground beef sirloin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. ground allspice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. ground cinnamon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup pine nuts, toasted")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. ground sumac, plus more for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE SHELL")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups fine bulgur")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground allspice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground cinnamon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small onion, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. lamb shoulder, trimmed"), _c('br'), _c('br'), _vm._v("Canola oil, for frying"), _c('br'), _vm._v("Plain yogurt, for serving"), _c('br'), _vm._v("Fresh mint leaves, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the filling: Heat oil in a 12″ skillet over medium heat. Add onion and cook, stirring, until soft, about 10 minutes. Add beef and cook, breaking it up with a wooden spoon, until no longer pink, about 7 minutes. Add salt, allspice, and cinnamon and cook, stirring, until meat begins to brown, about 4 minutes more. Transfer to a bowl, stir in nuts and sumac, and let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the shell: Rinse bulgur, squeeze out excess water, and place in a large bowl. Add salt, allspice, cinnamon, pepper, and onion, and set aside. Grind lamb twice in a meat grinder and add to bulgur mixture; knead mixture in bowl into a pliable paste, about 5 minutes. Cover bowl with a clean towel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Shape about "), _c('b', [_vm._v("¼")]), _vm._v(" cup of the bulgur-meat paste into a ball, moistening your hands with water as you work. Hold ball in one hand and insert index finger of other hand into center to form a hole. Shape ball into a thin-walled (about "), _c('b', [_vm._v("¼")]), _vm._v("″ thick) oval with an opening at one end by molding ball around finger, gradually tapering closed end. Mend any cracks in shell with a moistened finger. Fill hole with 1"), _c('b', [_vm._v("½")]), _vm._v(" tbsp. of the filling. Moisten edges of opening, then gather edges together to seal. Gently form kibbeh into the shape of an egg, and keep moist under a clean dish towel. Repeat shaping with remaining filling and bulgur-meat paste to make 16 egg-shaped balls in all.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Pour oil to a depth of 2″ into a 6-qt. Dutch oven and heat over medium heat until a deep-fry thermometer reads 375°. Working in batches, fry kibbeh until browned all over, about 4 minutes. Drain on paper towels. Transfer to a serving platter and spoon some yogurt alongside the kibbeh. Drizzle oil over yogurt, and sprinkle with more sumac. Serve with mint leaves on the side.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("STEAK TARTARE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Tartare de Filet de Bœuf")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This steak tartare recipe, inspired by the tableside preparation at Brasserie Georges in Lyon, France, gets a zip of acidity from cornichons, capers, and Dijon mustard.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("14")]), _c('td', [_vm._v("oz. center-cut beef tenderloin, trimmed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. Dijon mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("egg yolks")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup canola oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("tbsp. salt-packed capers, rinsed, drained, and minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. minced green niçoise olives")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. minced fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("1"), _c('b', [_vm._v("½")])])]), _c('td', [_vm._v("tsp. Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. Tabasco sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cornichons, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small onion, minced"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste"), _c('br'), _c('span', {
    attrs: {
      "href": "#/cap10#bistroFrenchFries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bistro French Fries")]), _vm._v(", for serving (optional)"), _c('br'), _vm._v("Mixed salad greens, for serving (optional)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put beef in the freezer to firm, about 30 minutes; this will make it easier to chop finely. Meanwhile, whisk mustard and egg yolks in a large bowl; while whisking constantly, slowly pour in oil to create a mayonnaise. Add capers, olives, parsley, Worcestershire, hot sauce, cornichons, and onion and season with salt and pepper; refrigerate flavorings until ready to use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Remove beef from freezer and cut into "), _c('b', [_vm._v("¼")]), _vm._v("″ cubes. Transfer beef to bowl of flavorings and stir to combine. Keep beef mixture chilled until ready to serve.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" To serve, divide beef mixture into 4 equal portions, and shape each into an oval disk on a serving plate. Serve immediately with fries and mixed greens, if you like.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("BEEF CARPACCIO")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Today, almost anything thinly sliced gets called “carpaccio,” but the name of this 1950 Harry’s Bar creation originally referred to its color: It was named for the great Venetian painter Vittorio Carpaccio, noted for his vivid use of reds and whites. The dish was inspired by the Contessa Amalia Nani Mocenigo, a steady customer whose doctor had forbidden her to eat cooked meat.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("egg yolk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. white wine vinegar or red wine vinegar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("pinches of dry mustard"), _c('br'), _vm._v("Kosher salt and freshly ground white pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup olive oil"), _c('br'), _vm._v("Juice of "), _c('b', [_vm._v("½")]), _vm._v(" lemon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1–2")]), _c('td', [_vm._v("dashes Worcestershire sauce, or to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. milk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. top sirloin or other best-quality beef, trimmed of all fat, sinew, and gristle")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make a mayonnaise by combining egg yolk, vinegar, mustard, and a little salt and pepper in a medium mixing bowl and whisking until foamy and thoroughly blended. Add "), _c('b', [_vm._v("¼")]), _vm._v(" cup oil drop by drop, whisking constantly. Gradually add the rest of the oil in a thin, steady stream, continuing to whisk as the mayonnaise thickens. Add 1 tbsp. lemon juice, or to taste, and adjust seasonings, whisking in a little water to thin the mayonnaise, if you like.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Put "), _c('b', [_vm._v("½")]), _vm._v(" cup mayonnaise (reserve the rest for another use) in a small bowl; whisk in Worcestershire and "), _c('b', [_vm._v("¼")]), _vm._v(" tsp. lemon juice, then enough milk to make a thin sauce that just coats the back of a wooden spoon. Season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" To assemble, make sure the beef is very cold, then slice into the thinnest possible slices, using a razor-sharp, long-bladed slicing knife (see Slicing Carpaccio, below). Divide slices among 6 small chilled plates, arranging them in one thin layer, covering the surface completely. Drizzle some of the sauce over the meat on each plate and serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("SLICING")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("CARPACCIO")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_vm._v("The secret to slicing carpaccio is a very cold—nearly frozen—piece of meat trimmed of all fat and gristle, and a long, sharp slicing knife. Cut at an angle across the grain, shaving off thin pieces until you’ve got a wide, even surface. The goal: sheets about "), _c('b', [_vm._v("⅛")]), _vm._v("″ thick.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("COUNTRY-STYLE PÂTÉ")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 10–20")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("There are as many variations on this rustic French terrine as there are picturesque French farmhouses; this recipe brings together our favorite elements of the many dozens we’ve tried.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("lb. whole chicken legs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup white wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tsp. fresh thyme leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("2")])]), _c('td', [_vm._v("tsp. chopped fresh rosemary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8–10")]), _c('td', [_vm._v("bay leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("sprigs fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small yellow onion, peeled and chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. rind from pork fat"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("slices stale bread, crusts removed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("clove garlic, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("lb. veal, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("lb. pork, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("lb. ground pork")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. chicken livers, trimmed and halved")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("7")]), _c('td', [_vm._v("oz. prosciutto, diced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("oz. cold fresh fatback, diced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup cognac"), _c('br'), _vm._v("Pinch "), _c('i', [_vm._v("each")]), _vm._v(" of ground allspice and mace")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. saltpeter (potassium nitrate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("large sheets caul fat, or thinly sliced fatback")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Cut chicken legs into drumsticks and thighs, then remove thigh meat from the bone, remove skin, and cut meat into thick strips. Reserve skin, bones, and drumsticks for stock. Mix together wine, oil, 1 tsp. thyme, 1 tsp. rosemary, and 2 bay leaves in a small bowl, then add thigh meat, cover, and refrigerate for 4 hours or up to overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Pour 6 cups water in a heavy pot; add reserved chicken drumsticks, bones, and skin, 1 bay leaf, 3 sprigs parsley, onions, pork rind, and salt and pepper; bring to a boil over medium heat. Reduce heat to low and gently simmer for about 2"), _c('b', [_vm._v("½")]), _vm._v(" hours. Strain stock, discard solids, return stock to pot, and increase heat to high. Boil until stock has reduced to about "), _c('b', [_vm._v("½")]), _vm._v(" cup. Remove from heat and let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat oven to 325°. Pulse bread, garlic, and remaining 1 sprig parsley in a food processor to make fine crumbs. Put stock, bread crumbs, veal, chopped and ground pork, livers, prosciutto, fatback, cognac, allspice, mace, saltpeter, and remaining 2 tsp. thyme and 1 tsp. rosemary in a large bowl and season liberally with salt and pepper. Mix thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Line a 6-cup terrine with caul fat, draping it over sides, then pack one-third of meat mixture evenly into terrine. Lay half the marinated chicken pieces on top of meat. Repeat layers, ending with meat. Fold caul fat over meat to wrap completely, arrange remaining 5–7 bay leaves on top, and cover with a double layer of aluminum foil. Set terrine in a baking pan, add enough boiling water to come two-thirds of the way up sides of terrine, and bake until a thermometer inserted in center reads 160°, about 2"), _c('b', [_vm._v("¾")]), _vm._v(" hours. Remove from oven, pour off water, then return terrine to baking pan. Remove foil, cover terrine with plastic wrap, then place a piece of heavy cardboard, cut to fit, inside the terrine. Weight with a couple of heavy cans. Refrigerate, still weighted, for 1–3 days, then serve in "), _c('b', [_vm._v("½")]), _vm._v("″-thick slices.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("PÂTÉ")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("THE MOLD")])]), _vm._v(" Hinged rectangular metal molds are often used for pâtés; the sides unhook, so the pastry isn’t damaged when unmolding. Terrines are baked in rectangular, oval, or round molds with straight, high sides. Traditionally made of earthenware, they also come in porcelain and enameled cast iron. Game pâtés are sometimes baked in oval molds whose sculpted lids depict a duck, rabbit, or the like, to indicate the contents.")]), _vm._v(" "), _c('p', {
    staticClass: "left_s1"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("THE FAT")])]), _vm._v(" To keep terrines from drying out during baking, molds are lined with caul fat (the white lacy membrane that lines the pig’s stomach) or thin sheets of fatback (the pure-white fat found under the skin on the pig’s back; ask your butcher to thinly slice the fatback for you). Diced fatback is often added to meat pâtés and terrines to provide moisture and to make them more tender.")]), _vm._v(" "), _c('p', {
    staticClass: "left_s1"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("THE SALTPETER")])]), _vm._v(" Also known as potassium nitrate, this natural substance is used (in tiny amounts) to inhibit spoilage and preserve the rosy color of meats.")]), _vm._v(" "), _c('p', {
    staticClass: "left_s1"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("TO STORE")])]), _vm._v(" Wrapped tightly in plastic and refrigerated, a meat terrine will keep for about 7 days; those made of fish or liver, about 2 days.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SEARED FOIE GRAS WITH CARAMELIZED PINEAPPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Buttery foie gras is seared and placed atop caramelized pineapple and drizzled with a syrupy port sauce. This appetizer is a famous and now classic dish that’s served at Wolfgang Puck’s Chinois on Main in Santa Monica.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('b', [_vm._v("FOR THE SAUCE")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cups port")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cups red wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅔")])]), _c('td', [_vm._v("cup plum wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("shallots, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups veal stock")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cinnamon stick")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. cold unsalted butter, cubed")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE GARNISH")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup port")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup plum wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. light brown sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("4″ piece fresh ginger, peeled and julienned")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE FOIE GRAS & PINEAPPLE")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_c('b', [_vm._v("¼")]), _vm._v("″-thick rings fresh ripe pineapple")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. peanut oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("2-oz. slices cold foie gras"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup flour")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the sauce: Combine port, red wine, plum wine, and shallots into a medium saucepan and bring to a boil over medium-high heat. Reduce heat to medium and cook, stirring occasionally, until reduced by half, about 30 minutes. Add stock and cinnamon and cook until liquid has reduced to about 1 cup, about 30–35 minutes. Strain through a fine-mesh sieve and return sauce to pan. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the garnish: Put port, plum wine, sugar, and ginger in a small pot and bring to a boil over medium heat. Reduce heat to medium-low and cook until syrupy, about 35 minutes. Remove from heat and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Make the foie gras and pineapple: Sprinkle sugar evenly over tops of pineapple slices and caramelize with a kitchen torch. Set aside in a single layer. Heat oil in a large skillet over medium-high heat. Season each piece of foie gras, then dredge lightly in flour, shaking off any excess. Sear foie gras on both sides until crisp and golden brown, 1–1"), _c('b', [_vm._v("½")]), _vm._v(" minutes per side. Transfer to a paper towel–lined plate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" To assemble, bring sauce to a simmer over medium heat. Reduce heat to low and whisk in butter, a little at a time, until smooth and glossy. Place 1 piece of pineapple on each of 4 warm plates and top each with a slice of foie gras. Spoon sauce over foie gras, then top with a dollop of the ginger garnish and some of its syrup. Serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("HOR MOK")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Steamed Thai Fish Custard")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Typically steamed in intricately folded banana leaves, in our simplified version these Thai-style fish custards are baked in banana leaf–lined ramekins set in a water bath.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. boneless, skinless halibut, grouper, or snapper filets, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups canned coconut milk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup Thai red curry paste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. fish sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. finely chopped palm sugar or packed dark brown sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("eggs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("13")]), _c('td', [_vm._v("kaffir lime leaves, very thinly shredded"), _c('br'), _vm._v("Kosher salt, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("large fresh or frozen banana leaves, wiped with a damp towel (optional)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup packed finely torn fresh basil leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. cornstarch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("red Thai chile, stemmed, very thinly sliced crosswise")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 350°. Process fish, 1 cup coconut milk, curry paste, fish sauce, 2 tsp. sugar, and eggs in a food processor until very smooth, 1–2 minutes. Stir in 12 shredded lime leaves, season with salt, and set fish custard aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" If you wish to use banana leaves, lay the banana leaves out on a surface and use scissors to cut out 8 circles, each 6″ in diameter. Place a banana leaf circle, shiny side down, over each of eight 8-oz. ramekins. Press circles into bottom and up the sides of ramekins so that they are nestled snugly inside. Divide half the fish custard among ramekins, top each with basil leaves, and cover with remaining custard. (If not using banana leaves, simply layer custard and basil leaves directly in ramekins.) Place ramekins in a 9″×13″ baking pan; pour boiling water into pan so that it comes halfway up sides of ramekins. Bake until custards set and begin to pull away from banana leaves or sides of ramekins, about 16 minutes. Meanwhile, heat remaining 1 cup coconut milk and "), _c('b', [_vm._v("½")]), _vm._v(" tsp. sugar with cornstarch in a 1-qt. saucepan over medium-high heat; cook, stirring, until thickened, about 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Remove pan from oven and remove ramekins from water. Top each with some of the thickened coconut milk, and sprinkle with remaining shredded lime leaf and chiles.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('b', [_vm._v("GRAVLAX")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Cured Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 8–10")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Silky, luxurious Scandinavian-cured salmon requires little more than salt, sugar, and time. Dill is the traditional flavoring, but the seasonings can be adjusted to suit your taste—we like adding fennel and caraway seeds, to bring out the flavor of the aquavit.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. white peppercorns")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. fennel seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. caraway seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅔")])]), _c('td', [_vm._v("cup kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup sugar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("2-lb. center-cut, skin-on salmon filet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup fresh dill sprigs, plus "), _c('b', [_vm._v("⅓")]), _vm._v(" cup chopped dill")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup aquavit"), _c('br'), _c('span', {
    attrs: {
      "href": "#/cap15#mustardDillSauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mustard-Dill Sauce")]), _vm._v(", for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" In a small food processor, pulse peppercorns, fennel seeds, and caraway seeds until coarsely ground; combine with salt and sugar. Stretch plastic wrap over a plate; sprinkle with half the salt mixture. Place salmon filet on top, flesh side up. Cover with remaining salt mixture, dill sprigs, and aquavit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Fold plastic wrap ends around salmon; wrap tightly with more plastic wrap. Refrigerate the fish on the plate for 48–72 hours, turning the package every 12 hours and using your fingers to redistribute the herb-and-spice-infused brine that accumulates as the salt pulls moisture from the salmon. The gravlax should be firm to the touch at the thickest part when fully cured.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Unwrap salmon, discarding the spices, dill, and brine. Rinse the filet under cold running water and pat dry with paper towels. Cover a large plate with the chopped dill. Firmly press the flesh side of the gravlax into the dill to coat it evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Place gravlax skin side down on a board. With a long, narrow-bladed knife, slice gravlax against grain, on the diagonal, into thin pieces. Serve with mustard-dill sauce. Refrigerate any remaining gravlax, wrapped in plastic wrap, for up to 2 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" The longer the gravlax cures, the drier the flesh will become, the more intense its flavor, and the easier it will be to slice.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("HAWAIIAN POKE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Poke, a popular Hawaiian dish, is a mixture of cubed raw fish mixed with seaweed and chiles. Be sure to use only the freshest fish.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. fresh ahi tuna or other tuna")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("1 medium tomato, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup limu seaweed (or any rehydrated or sashimi-grade seaweed), chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup finely chopped sweet onion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. Asian sesame oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. crushed red chile flakes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. soy sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Chop tuna into "), _c('b', [_vm._v("½")]), _vm._v("″ cubes. Place in a large bowl and gently toss with tomatoes, seaweed, onions, oil, and chile flakes. Add soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" For fried poke, a less common but nevertheless traditional variation, prepare the poke as instructed. Heat 1 tbsp. vegetable oil in a wok or skillet over high heat. Fry the poke over high heat for 2–3 minutes. Serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("VUELVE A LA VIDA")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Veracruzan Shellfish Cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("This dish from the Mexican state of Veracruz is reputed to be a hangover remedy—its name literally means “return to life.” Use whatever shellfish is freshest.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup ketchup")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped white onion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. extra-virgin olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. orange juice"), _c('br'), _vm._v("Juice of 2 limes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup clam juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("lb. cooked shelled seafood (for instance, 1"), _c('b', [_vm._v("½")]), _vm._v(" lb. lobster, "), _c('b', [_vm._v("¼")]), _vm._v(" lb. shrimp, and "), _c('b', [_vm._v("¼")]), _vm._v(" lb. crab)"), _c('br'), _vm._v("Kosher salt and freshly ground white pepper, to taste"), _c('br'), _vm._v("Diced avocado, chopped fresh cilantro, and chopped white onion, for serving"), _c('br'), _vm._v("Lime wedges, for garnish")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" In a large bowl, stir together ketchup, onions, oil, orange juice, lime juice, clam juice, and 1"), _c('b', [_vm._v("½")]), _vm._v(" cups water.")])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Roughly chop seafood and stir into sauce. Season with salt and pepper. Top with avocado, cilantro, and onions. Garnish with lime wedges.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("FRITTO MISTO DI MARE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Mixed Seafood Fry")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Simply fried assorted seafood is a popular appetizer all over coastal Italy—and especially along the shores of the Adriatic.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups flour"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup milk"), _c('br'), _vm._v("Vegetable oil for frying")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. whitebait or smelts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("lb. cleaned squid or cuttlefish bodies, cut into 1″ rings")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. small shrimp, peeled and deveined"), _c('br'), _vm._v("Arugula, for serving")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("lemons, cut into wedges, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Put flour in a medium bowl, season with salt and pepper, and mix thoroughly. Pour milk into a separate bowl. Pour oil to a depth of about 3″ into a deep skillet and heat over medium-high heat until a deep-fry thermometer reads 350°. Meanwhile, dip fish in milk, a few pieces at a time, then dredge in flour. Repeat process, dipping squid and shrimp first in milk, then in flour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Shake excess flour from fish and seafood, then fry in batches, turning occasionally, until crisp and golden, about 3 minutes per batch. Drain on paper towels, sprinkle with salt, and then transfer to a large platter. Serve on a bed of arugula, with lemon wedges on the side.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("HOT")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("TIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_vm._v("Monitoring oil temperature is crucial when you’re frying foods (like "), _c('i', [_vm._v("fritto misto")]), _vm._v("): too hot, your food will burn; not hot enough, it’ll come out greasy. A deep-fry thermometer works, but another method appeals to the minimalist in us: Asian cooks simply stick an unvarnished wooden or bamboo chopstick into the oil to test the heat. If the oil is hot enough, a steady stream of bubbles will issue from the submerged end, as moisture trapped inside the wood or bamboo boils and escapes as steam when exposed to the hot oil. The hotter the oil, the more bubbles there will be. Give the chopstick a dip at 350°, there will be a swirl of bubbles all over; by 375°, the swirl will reach Jacuzzi-esque force. It takes a few fry-ups to master the reading of bubble intensity as clearly as one would the needles of a thermometer, but once one has, there’s something wonderfully Zen about dispensing with cooking by the numbers.")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SHRIMP COCKTAIL")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("No dish showcases shrimp quite so elegantly as a shrimp cocktail. Poaching the shrimp in advance in an aromatic, wine-enriched broth brings out their sweetness, the better to pair with a piquant cocktail sauce. The classic steak-house presentation has the cocktail sauce divided among martini glasses with the shrimp perched along the rim of each glass. But for a less formal presentation, a communal platter will do.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE COCKTAIL SAUCE")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup ketchup")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. drained prepared horseradish")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. Tabasco sauce"), _c('br'), _vm._v("Pinch of kosher salt")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE SHRIMP")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups dry white wine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. black peppercorns")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("sprigs fresh thyme")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("small bunch fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("yellow onion, sliced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("rib celery, chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("bay leaf"), _c('br'), _vm._v("Kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("16")]), _c('td', [_vm._v("jumbo shrimp (about 1 lb.), unpeeled")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the cocktail sauce: Put ketchup, horseradish, lemon juice, Worcestershire, Tabasco, and salt into a medium bowl and stir well. Cover and refrigerate.")])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the shrimp: Put wine, peppercorns, thyme, parsley, onions, celery, bay leaf, and 8 cups water into a large pot. Season the liquid generously with salt and bring to a boil. Reduce heat to medium-low and simmer for 30 minutes.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Add shrimp and cook, stirring occasionally, until just cooked through, 2–3 minutes. Drain shrimp, transfer to a baking sheet, and spread into a single layer; let cool to room temperature. Refrigerate shrimp until completely chilled, then peel them and serve with the cocktail sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("NEW ORLEANS BARBECUED SHRIMP")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("There’s no barbecue involved in this classic New Orleans dish, just a lip-smacking combination of Worcestershire and hot sauces, butter, and tangy spices—a recipe that was perfected, in our opinion, at Mr. B’s Bistro in New Orleans. The sweet peel-and-eat jumbo shrimp may look like the main attraction, but sopping up the sauce juices with a hunk of bread is, by all accounts, truly the best part.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. unsalted butter, plus 12 tbsp., cut into "), _c('b', [_vm._v("½")]), _vm._v("″ cubes and chilled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup hot sauce, such as Crystal")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup Worcestershire sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. fresh lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. Creole seasoning")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tsp. freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("lb. large shrimp, heads on, unpeeled"), _c('br'), _vm._v("Kosher salt, to taste"), _c('br'), _vm._v("French bread, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Heat 3 tbsp. butter in a 12″ skillet over medium-high heat. Add garlic and cook until soft, 1–2 minutes. Add hot sauce, Worcestershire, juice, Creole seasoning, and pepper and bring to a simmer. Cook until sauce is reduced by half, 5–7 minutes. Add shrimp and cook, flipping once, until cooked through, 3–4 minutes. Reduce heat to medium-low and stir in chilled butter to make a smooth sauce. Season with salt. Serve with French bread.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "oystersRockefeller"
    }
  }, [_c('b', [_vm._v("OYSTERS ROCKEFELLER")])])]), _c('a', {
    attrs: {
      "id": "oystersRockefeller"
    }
  }, [_c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Oysters Rockefeller were created in New Orleans, at the legendary restaurant Antoine’s. The precise recipe is kept a secret, but we do know that neither bacon nor spinach is involved—common inclusions at other restaurants. Instead, the oysters are topped with a roux full of herbs and aromatics, then combined with bread crumbs and broiled until a delicate crust forms.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _c('td', [_vm._v("Rock salt, as needed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("12")]), _c('td', [_vm._v("oysters, such as bluepoint, chilled")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tbsp. unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("tbsp. flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. cayenne pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("scallions, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("ribs celery, minced"), _c('br'), _vm._v("Leaves from 2 sprigs fresh tarragon, minced"), _c('br'), _vm._v("Leaves from 1 bunch fresh parsley, minced, plus sprigs for garnish"), _c('br'), _vm._v("Kosher salt and freshly ground white pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. fresh bread crumbs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Fill 2 ovenproof baking dishes halfway with rock salt. Shuck oysters over a bowl to catch their liquor (you should have about "), _c('b', [_vm._v("½")]), _vm._v(" cup), discarding flat top shells. Loosen oysters from bottom shells with a knife. Nestle 6 shucked oysters in their shells into each bed of rock salt; chill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Melt butter in a 2-qt. saucepan over medium heat. Add flour and cook, stirring, until smooth, about 2 minutes. Add oyster liquor; cook until thickened to a paste, about 2 minutes. Stir in cayenne, scallions, celery, tarragon, parsley, and salt and pepper. Reduce heat to medium-low and cook until soft, about 1 hour. Transfer to a food processor, add bread crumbs, and process into a smooth paste, about 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat broiler. Place paste in a pastry bag fitted with a "), _c('b', [_vm._v("½")]), _vm._v("″ fluted tip. Pipe paste completely over oysters. Broil until paste begins to brown and oysters are just cooked through, 5–7 minutes. Garnish with parsley sprigs.")])]), _c('p', {
    staticClass: "r_head"
  }, [_c('a', {
    attrs: {
      "id": "oystersRockefeller"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('b', [_vm._v("FRIED OYSTERS WITH SPICY RÉMOULADE")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Chef Frank Stitt of Highlands Bar and Grill in Birmingham, Alabama, uses the bottom oyster shells as serving platters for these crispy fried oysters with a piquant rémoulade sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE RÉMOULADE")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. minced cornichons")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. minced fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. minced capers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. whole-grain mustard")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. minced fresh tarragon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. minced shallots")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. sherry vinegar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. minced oil-packed anchovies")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. paprika")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("dashes Tabasco sauce"), _c('br'), _vm._v("Grated zest of 1 lemon"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE OYSTERS")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }), _c('td', [_vm._v("Canola or peanut oil, for frying")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups cornmeal")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¾")])]), _c('td', [_vm._v("cup flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups buttermilk")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("24")]), _c('td', [_vm._v("medium oysters, such as bluepoint or"), _c('br'), _vm._v("Apalachicola, shucked, bottom shells reserved")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the rémoulade: In a medium bowl, combine all the ingredients. Stir to combine; season with salt and pepper. Cover and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the oysters: Pour oil to a depth of 2″ into a 4-qt. pot and heat over medium heat until a deep-fry thermometer reads 350°. Meanwhile, whisk together cornmeal and flour in a shallow dish and season with salt and pepper. Pour buttermilk into another shallow dish. Working in small batches, dip oysters in buttermilk and then in cornmeal mixture, tossing to coat. Transfer oysters to a rack set inside a baking sheet. Working in batches, add oysters to oil and fry, turning occasionally, until golden brown and crisp, about 2 minutes. Using a slotted spoon, transfer oysters to paper towels. Spoon some of the reserved rémoulade into the reserved oyster shells and top with fried oysters. Serve warm.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("NEW ORLEANS,")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("OYSTER CITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  })]), _c('div', {
    staticClass: "box1"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "left_s1"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("New Orleans is an oyster lover’s town: They’re emblematic, hungrily sought after, and seemingly everywhere. At the raw bar at Pascal’s Manale, shucker Thomas Stewart opens them by the thousands to be eaten the Gulf way: raw on a saltine with hot sauce and horseradish. The white-tiled oyster sanctuary Casamento’s charbroils them, each shell a vessel for gurgling butter, garlic, and parmesan cheese. At Upperline, they’re deep-fried and served atop a zesty, garlicky sauce. At Antoine’s, there’s a kingly platter known as the 2-2-2: oysters Bienville, baked in a white wine–cream sauce; ")]), _c('a', {
    attrs: {
      "href": "#/cap01#oystersRockefeller"
    }
  }, [_vm._v("Rockefeller, smothered in puréed herbs")]), _vm._v("; and Thermidor, with bacon and tomato sauce. New Orleans’ oyster cookery is so evolved largely due to abundance: Louisiana is a prolific oyster-producing state. The type in the Gulf of Mexico, "), _c('i', [_vm._v("Crassostrea virginica")]), _vm._v(", are large, plump, mild specimens that lend themselves well to both raw and cooked preparations. Early on, the plentiful mollusks were swapped in for escargots in Creole versions of classic French dishes, and cooks kept going from there. Sal Sunseri, a coproprietor of P&J’s Oyster Company with his brother Al, told us what he looks for in one: “Louisiana oystermen say they’re looking for a ‘cock’ oyster, because it has the colors, like purple and copper, you’d see on a cockleshell. Those show that the oyster’s feeding well, and everything’s salty and good—all you have to do is suck it up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("BRIGTSEN’S OYSTERS LERUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Sweet crabmeat and shrimp enrich the stuffing of these broiled mollusks, famously served at Brigtsen’s restaurant in New Orleans.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("tbsp. unsalted butter")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("scallions, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("rib celery, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("small yellow onion, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. finely chopped fresh thyme")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. cayenne pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. celery seeds")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("bay leaf"), _c('br'), _vm._v("Kosher salt and freshly ground white pepper, to taste")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. medium shrimp (about 5), peeled, deveined, and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup heavy cream")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("oz. crabmeat, picked of shells")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup fresh bread crumbs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup grated Parmigiano-Reggiano"), _c('br'), _vm._v("Coarse rock salt, for pan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("12")]), _c('td', [_vm._v("large bluepoint oysters, on the half shell")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. paprika")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Melt butter in a 2-qt. saucepan over medium-high heat. Add garlic, scallions, celery, and onion and cook, stirring occasionally, until golden, 4–6 minutes. Add parsley, thyme, cayenne, celery seeds, bay, salt, and pepper and cook until fragrant, 1 minute. Add shrimp and cook until just pink, 1–2 minutes. Add flour and cook for 1 minute. Add cream and bring to a boil; remove from heat and stir in crab, bread crumbs, and cheese. Transfer to a pastry bag fitted with a "), _c('b', [_vm._v("½")]), _vm._v("″ fluted tip; refrigerate until cold, at least 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat broiler. Line a baking sheet with rock salt about "), _c('b', [_vm._v("¼")]), _vm._v("″ deep. Nestle oysters into bed of rock salt. Pipe filling over oysters and sprinkle with paprika; broil until tops are browned, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "line01"
  }), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("“As I ate the oysters with their strong taste of the sea and their faint metallic taste that the cold white wine washed away, leaving only the sea taste and the succulent texture, and as I drank their cold liquid from each shell and washed it down with the crisp taste of the wine, I lost the empty feeling and began to be happy and to make plans.”"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERNEST HEMINGWAY")])])])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "line02"
  }), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("CLAMS CASINO")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("Butter, shallots, paprika, and salt slathered over littleneck clams is an inspired combination that you’ll find in restaurants across the country. The dish, however, is thought to have been invented in 1917 by restaurateur Julius Keller, proprietor of the Little Casino in Narragansett, Rhode Island—a true clam town.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _c('td', [_vm._v("Rock salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("24")]), _c('td', [_vm._v("littleneck or cherrystone clams, scrubbed")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("8")]), _c('td', [_vm._v("tbsp. unsalted butter, softened")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("shallots, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("tsp. paprika"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("slices bacon, cut crosswise into 1″ pieces")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Move oven rack to top third of oven and heat oven to 500°. Fill a large baking dish halfway with rock salt and set aside. Using a clam or paring knife, shuck clams, loosening clam meat from top shell, and discard top shell, then loosen clam meat from bottom shell. Nestle shucked clams in their shell into rock salt and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Put butter, shallots, paprika, and salt and pepper to taste into a small bowl and mix well. Spoon about 1 tsp. of the seasoned butter onto each clam and top each with a piece of bacon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Bake clams until edges of bacon are crisp and butter is golden brown and bubbling, about 5 minutes. Serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COOK’S NOTE")])])]), _vm._v(" Can’t find rock salt at the supermarket? Look for it in a hardware store.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("STAMP & GO")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Jamaican Salt Cod Fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("These Jamaican road snacks are possibly named for the way travelers would stamp their feet at food stands to hail vendors. This recipe pairs the fritters with a sauce made with culantro, an herb with a cilantro-like flavor.")])]), _c('p', {
    staticClass: "s_head0"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('b', [_vm._v("FOR THE CULANTRO SAUCE")])])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups mayonnaise")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup finely chopped fresh culantro or cilantro")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. white wine vinegar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. fresh lime juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. grated lime zest")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. finely chopped fresh basil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. finely chopped fresh thyme")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("Scotch bonnet or habanero chile, stemmed, seeded, and minced"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE FRITTERS")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("lb. dried salt cod")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. canola oil, plus more for frying")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("cloves garlic, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("small yellow onions, minced")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("scallions, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("Scotch bonnet or habanero chile, stemmed, seeded, and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. baking powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. ground black pepper")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("eggs, lightly beaten")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the culantro sauce: Whisk together all ingredients in a bowl and season with salt and pepper; chill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the fritters: Place cod in a 2-qt. saucepan, and cover by 2″ with cold water; bring to a boil over high heat, and cook for 20 minutes. Drain cod, return to saucepan, and repeat process twice more. Transfer cod to a bowl, and flake with a fork into large chunks; set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat 1 tbsp. oil in a 12″ skillet over medium-high heat. Add garlic, onions, scallions, and chile and cook, stirring, until soft, about 10 minutes. Remove from heat and let cool; set aside. In a large bowl, whisk together flour, baking powder, salt, and pepper; add eggs and stir until a dough forms. Add reserved cod and cooked vegetables and stir gently until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("4")]), _vm._v(" Pour oil to a depth of 2″ into a 6-qt. Dutch oven, and heat over medium-high heat until a deep-fry thermometer reads 350°. Using a tablespoon, drop rounds of dough into oil and fry until golden brown, about 3 minutes; repeat with remaining dough. Using a slotted spoon, transfer fritters to paper towels to drain briefly. Serve immediately with culantro sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("STUFFED ROMAINE LEAVES WITH AVGOLÉMONO SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 4")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_c('i', [_vm._v("Avgolémono")]), _vm._v(" sauce is a traditional Greek lemon sauce, often drizzled over dolmades. This recipe, in which lettuce leaves are filled with an herbaceous meat mixture, was inspired by the new breed of Athenian ouzo bar owner-chefs, who mix traditional foods and flavors with new ingredients to enhance their eclectic menus.")]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE FILLING")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("lb. ground lamb")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("lb, ground beef")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("lb. ground pork")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup toasted pine nuts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup dried currants")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. finely chopped fresh dill")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. finely chopped fresh mint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. finely chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground cloves")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. ground cinnamon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup cooked white rice"), _c('br'), _vm._v("Kosher salt and freshly ground black pepper, to taste")])])])]), _vm._v(" "), _c('p', {
    staticClass: "s_head0"
  }, [_c('b', [_vm._v("FOR THE AVGOLÉMONO SAUCE")])]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("cup chicken stock")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("eggs")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("3")]), _c('td', [_vm._v("tbsp. lemon juice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. cornstarch")])]), _vm._v(" "), _c('tr', [_c('td'), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("heads romaine lettuce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Make the filling: In a large heavy skillet, sauté lamb, beef, and pork until cooked, about 10 minutes. Remove from heat and drain fat. Stir in pine nuts, currants, dill, mint, parsley, cloves, cinnamon, rice, and salt and pepper, then remove from heat and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Make the sauce: Heat stock. In a separate bowl, beat together eggs and lemon juice mixed with cornstarch. Whisk hot stock into egg-lemon mixture, "), _c('b', [_vm._v("¼")]), _vm._v(" cup at a time, and place in the top of a double boiler over low heat. Cook until sauce thickens to the consistency of yogurt, about 10 minutes.")])]), _c('p', {
    staticClass: "noindent_n"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Bring a large pot of salted water to a boil. Remove outer dark leaves of heads of lettuce, cutting off and reserving top half of each leaf (reserve inner leaves and cores for another use). Blanch leaf halves in boiling water for 5 seconds to soften. Place 2 heaping tbsp. filling at the base of a leaf. Fold over sides and carefully roll up. Repeat with remaining leaves. Place seam side down on a platter. Spoon extra filling around the stuffed leaves. Top with warm avgolémono sauce.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("SCALLION PANCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Cong You Bing")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("SERVES 6")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("These light and flaky scallion pancakes, an iconic, hugely popular dish throughout China and now a staple of Chinese restaurants in America, get a hit of heat from crushed red chile flakes.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("4")]), _c('td', [_vm._v("cups flour")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. baking powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("⅓")])]), _c('td', [_vm._v("cup canola oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("tbsp. Asian sesame oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup thinly sliced scallions")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tsp. crushed red chile flakes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("tsp. ground white pepper")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Process 2 cups flour and baking powder in a food processor. With motor running, add "), _c('b', [_vm._v("⅔")]), _vm._v(" cup cold water and process until dough forms, about 40 seconds. Transfer to a plate; set aside. Add remaining 2 cups flour and the salt to food processor. With motor running, add "), _c('b', [_vm._v("⅔")]), _vm._v(" cup boiling water and process until dough forms, about 30 seconds. Return reserved dough to food processor; pulse until both doughs come together, about 35 seconds. Transfer to a lightly floured work surface and knead until smooth, about 4 minutes. Transfer to a greased bowl, cover, and let sit at room temperature for 2 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Halve dough; using a rolling pin, roll 1 dough half into a 10″×20″ rectangle. Brush with 1 tbsp. canola oil and half the sesame oil. Sprinkle with half the scallions, half the chile flakes, and half the white pepper. Beginning with one long side, tightly roll dough like a jelly roll. Cut roll crosswise into 3 pieces, slightly stretch each piece, and starting from one edge, coil piece horizontally, tucking the end underneath. Using your hand, gently flatten coil into a disk; using a rolling pin, flatten into a 5″ circle. Repeat with remaining pieces and second dough half, 1 tbsp. canola oil, remaining sesame oil, scallions, chile flakes, and white pepper. Let pancakes sit for about 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("3")]), _vm._v(" Heat oven to 200°. Heat 2 tsp. canola oil in a 10″ nonstick skillet over medium heat. Add 1 pancake to skillet and cook, swirling skillet and turning once, until golden and crisp, about 10 minutes. Transfer to a baking sheet; place in oven to keep warm. Repeat with remaining oil and pancakes. Cut into wedges to serve.")]), _vm._v(" "), _c('p', {
    staticClass: "r_head"
  }, [_c('b', [_vm._v("KOREAN MUNG BEAN PANCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head1"
  }, [_c('i', [_vm._v("Bindaeduk Cho Kanjang")])]), _vm._v(" "), _c('p', {
    staticClass: "s_head"
  }, [_c('b', [_vm._v("MAKES ABOUT 30 PANCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "r_para"
  }, [_vm._v("These savory Korean pancakes are made from a batter of ground mung beans flecked with pork, scallions, and pungent kimchi.")]), _vm._v(" "), _c('table', {
    staticClass: "none",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("2")]), _c('td', [_vm._v("cups peeled, dried mung beans, soaked overnight and drained")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. boneless pork loin, trimmed and finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("lb. "), _c('span', {
    attrs: {
      "href": "#/cap15#cabbageKimchi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabbage Kimchi")]), _vm._v(" (or store-bought), rinsed, drained, and finely chopped (about "), _c('b', [_vm._v("½")]), _vm._v(" cup), plus "), _c('b', [_vm._v("½")]), _vm._v(" cup kimchi pickling liquid")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1"), _c('b', [_vm._v("½")])]), _c('td', [_vm._v("cups mung bean sprouts, roughly chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. kosher salt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("6")]), _c('td', [_vm._v("scallions, halved lengthwise and cut crosswise into 1″ pieces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("5")]), _c('td', [_vm._v("cloves garlic, finely chopped")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("½")])]), _c('td', [_vm._v("cup canola oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_c('b', [_vm._v("¼")])]), _c('td', [_vm._v("cup soy sauce")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right"
  }, [_vm._v("1")]), _c('td', [_vm._v("tbsp. white vinegar")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("1")]), _vm._v(" Purée mung beans and 1"), _c('b', [_vm._v("¾")]), _vm._v(" cups water in a food processor until smooth; transfer to a bowl. Add pork, kimchi and pickling liquid, sprouts, salt, scallions, and garlic; stir until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "colnum"
  }, [_vm._v("2")]), _vm._v(" Heat 2 tbsp. oil in a 12″ nonstick skillet over medium heat. Working in batches and adding more oil as needed, place "), _c('b', [_vm._v("¼")]), _vm._v(" cup of mixture in pan for each pancake. Cook, flipping once, until golden, 8–10 minutes. Transfer to paper towels to drain briefly, then place on a serving platter. Stir soy sauce and vinegar in a bowl; serve on the side for dipping.")])])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1caf37ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 72
// module chunks = 0